import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';

import Svg, {
  Circle,
  G,
  Path,
  Rect,
  Text,
  TSpan,
  Polygon,
  Polyline,
  Line,
  Defs,
  Mask,
  Use,
} from 'react-native-svg';
import { forSeverity, accent, primary } from '../../colours';
import { decorative } from './accessibility';

// export const NextSchedule = props => {
//   return (
//     <Svg width={24} height={24} viewBox="0 0 24 24" {...props}>
//       <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
//         <g fill="#000" fillRule="nonzero" transform="translate(4 3)">
//           <path d="M11.55 16.116v-.665h3.502a.53.53 0 00.377-.178.53.53 0 00.177-.376v-8.07H2.793v4.08h-.665V2.97c0-.325.118-.605.355-.842.236-.236.524-.355.864-.355h1.84V0h.776v1.773h6.54V0h.731v1.773h1.818c.34 0 .628.119.864.355.237.237.355.517.355.842v11.927c0 .325-.118.61-.355.853a1.159 1.159 0 01-.864.366h-3.503zM5.652 18l-.444-.443 2.793-2.86H0v-.687h8.002L5.21 11.172l.444-.465 3.657 3.658L5.653 18zM2.793 6.163h12.813V2.97a.495.495 0 00-.177-.365.545.545 0 00-.377-.167H3.347a.545.545 0 00-.377.167.495.495 0 00-.177.365v3.193zm0 0V2.438v3.725z" />
//         </g>
//       </g>
//     </Svg>
//   );
// };

export const WifiFull = props => {
  const { width = '16px', height = '13px' } = props;
  return (
    <Svg width={width} height={height} viewBox="0 0 16 13">
      <G
        id="Onboarding"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd">
        <G
          id="Step-1-Copy-3"
          transform="translate(-48.000000, -275.000000)"
          fill={props.fill || '#A0C735'}>
          <G id="Group-2" transform="translate(48.000000, 275.692308)">
            <Rect
              id="Rectangle"
              x="0"
              y="7.38461538"
              width="4.00144883"
              height="4.92307692"
            />
            <Rect
              id="Rectangle-Copy-5"
              x="11.0769231"
              y="-2.84217094e-14"
              width="4.00144883"
              height="12.3076923"
            />
            <Rect
              id="Rectangle-Copy-2"
              x="5.53846154"
              y="4.92307692"
              width="4.00144883"
              height="7.38461538"
            />
          </G>
        </G>
      </G>
    </Svg>
  );
};

export const WifiMed = props => {
  const { width = '16px', height = '8px' } = props;
  return (
    <Svg width={width} height={height} viewBox="0 0 16 8">
      <G
        id="Onboarding"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd">
        <G
          id="Step-1-Copy-3"
          transform="translate(-48.000000, -344.000000)"
          fill={props.fill || '#A0C735'}>
          <G id="Group-4" transform="translate(48.000000, 344.615385)">
            <Rect
              id="Rectangle-Copy"
              x="0"
              y="2.46153846"
              width="3.99922656"
              height="4.92307692"
            />
            <Rect
              id="Rectangle-Copy-6"
              x="11.0784531"
              y="4.92307692"
              width="3.99922656"
              height="2.46153846"
            />
            <Rect
              id="Rectangle-Copy-3"
              x="5.53922656"
              y="-1.42108547e-14"
              width="3.99922656"
              height="7.38461538"
            />
          </G>
        </G>
      </G>
    </Svg>
  );
};

export const WifiLow = props => {
  const { width = '16px', height = '5px' } = props;
  return (
    <Svg width={width} height={height} viewBox="0 0 16 5">
      <G
        id="Onboarding"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd">
        <G
          id="Step-1-Copy-3"
          transform="translate(-48.000000, -475.000000)"
          fill="#FFCD39">
          <G id="Group-5" transform="translate(48.000000, 475.076923)">
            <Rect
              id="Rectangle-Copy-4"
              x="0"
              y="-1.42108547e-14"
              width="4"
              height="4.92307692"
            />
            <Rect
              id="Rectangle-Copy-7"
              x="11.0769231"
              y="2.46153846"
              width="4"
              height="2.46153846"
            />
            <Rect
              id="Rectangle-Copy-8"
              x="5.53846154"
              y="2.46153846"
              width="4"
              height="2.46153846"
            />
          </G>
        </G>
      </G>
    </Svg>
  );
};

export const WifiNone = props => {
  const { width = '16px', height = '8px' } = props;
  return (
    <Svg width={width} height={height} viewBox="0 0 16 3">
      <G
        id="Onboarding"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd">
        <G
          id="Step-1-Copy-3"
          transform="translate(-48.000000, -541.000000)"
          fill="#F87171">
          <G id="Group-6" transform="translate(48.000000, 541.538462)">
            <Rect
              id="Rectangle-Copy-9"
              x="0"
              y="0"
              width="4.00075226"
              height="2.46153846"
            />
            <Rect
              id="Rectangle-Copy-10"
              x="11.0769231"
              y="0"
              width="4.00075226"
              height="2.46153846"
            />
            <Rect
              id="Rectangle-Copy-11"
              x="5.53846154"
              y="0"
              width="4.00075226"
              height="2.46153846"
            />
          </G>
        </G>
      </G>
    </Svg>
  );
};

export const Bin = props => {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <G fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <G fill="#FAFAFA" fillRule="nonzero" transform="translate(4.2 3.208)">
          <Path d="M2.656 17.585c-.41 0-.769-.154-1.076-.461a1.475 1.475 0 01-.462-1.077V1.566H0V.755h4.277V0h7.046v.727H15.6v.839h-1.118v14.481c0 .41-.15.77-.448 1.077a1.461 1.461 0 01-1.09.46H2.656zm10.987-16.02H1.957v14.482c0 .168.075.326.224.476.149.149.307.223.475.223h10.288c.168 0 .326-.074.475-.223.15-.15.224-.308.224-.476V1.566zM5.452 14.399h.838V3.858h-.838v10.54zm3.858 0h.838V3.858H9.31v10.54zM1.957 1.566v15.18-15.18z" />
        </G>
      </G>
    </Svg>
  );
};

export const Thermostat = props => {
  const c = props?.fill || '#000';
  return (
    <Svg viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" {...props}>
      <G
        transform="translate(1 1)"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd">
        <Circle stroke={c} cx={12} cy={12} r={12} />
        <Rect
          fill={c}
          x={16.645034}
          y={18.9877959}
          width={2.738286}
          height={1}
          rx={0.5}
        />
        <Rect
          fill={c}
          x={4.61667997}
          y={18.9877959}
          width={2.738286}
          height={1}
          rx={0.5}
        />
        <Circle stroke={c} cx={12} cy={19.2590412} r={2.68662023} />
      </G>
    </Svg>
  );
};

export function HotWater(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="26px"
      height="24px"
      viewBox="0 0 26 24"
      {...props}>
      <G
        transform="translate(-11 -12) translate(12 13.272)"
        stroke="#CAE08F"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd">
        <Path
          d="M24 21.456L21.456.877A1 1 0 0020.463 0H7.827a1.08 1.08 0 00-1.08 1.08c0 .613.464 1.126 1.074 1.187l5.802.574h0v3.981L1.52 7.363A1.521 1.521 0 00.43 7.9c-.275.325-.338.78-.16 1.168.932 2.033 2.49 3.049 4.675 3.049 3.616 0 7.256-.181 8.346 0 .726.12 1.202.661 1.426 1.623h0l.494 7.717H24z"
          strokeLinejoin="round"
        />
        <Path d="M13.4662921 5.415018L21.7333402 5.09501336" />
      </G>
    </Svg>
  );
}

export function HotWaterLrg(props) {
  return (
    <Svg
      width="62px"
      height="62px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <G
        stroke={props.stoke}
        transform="translate(3.9 4.487)"
        strokeWidth={0.5}
        fill="none"
        fillRule="evenodd">
        <Path
          d="M16.2 14.483L14.518.877A1 1 0 0013.525 0H5.283a.73.73 0 00-.73.73c0 .413.315.76.726.8l3.916.388h0v2.687l-8.168.365a1.027 1.027 0 00-.737.362.74.74 0 00-.109.788c.63 1.372 1.682 2.058 3.157 2.058 2.44 0 4.897-.122 5.632 0 .49.082.812.447.963 1.096h0l.334 5.209H16.2z"
          strokeLinejoin="round"
        />
        <Path d="M9.08974719 3.65513715L14.6700046 3.43913402" />
      </G>
    </Svg>
  );
}

export function HaloLoginDevices({ width = 218, height = 146.744 }) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 218 146.744">
      <Defs>
        <Path id="a" d="M0 19L101.647 19 101.647 0 0 0z" />
      </Defs>
      <G fill="none" fillRule="evenodd">
        <G stroke="#95C11F" transform="translate(1 1) translate(122.872)">
          <Path
            strokeLinejoin="round"
            strokeWidth={2}
            d="M0 3.354L76.475 0 93.128 5.593 93.128 132.778 76.475 144.744 0 136.089z"
          />
          <Path strokeLinejoin="round" d="M76.475 0L76.475 144.744" />
          <Path
            strokeLinejoin="round"
            d="M3.138 3.709L10.064 91.371 10.064 137.421"
          />
          <Path
            strokeLinejoin="round"
            d="M66.971 0L55.37 96.562 55.37 142.612"
          />
          <Path d="M76.475 95.708L55.37 98.708 10.064 95.708 0 91.758" />
        </G>
        <G transform="translate(1 1) translate(0 55.228)">
          <Path
            fill="#181818"
            stroke="#95C11F"
            strokeWidth={2}
            d="M0 0H112.381V76.532H0z"
          />
          <Circle
            cx={71.323}
            cy={38.259}
            r={30.67}
            fill="#181818"
            stroke="#95C11F"
          />
          <Path
            stroke="#95C11F"
            d="M59.44 53.615c2.234.87 5.167.59 7.086-.683 2.51-1.667 4.857-3.908 4.593-9.981a3.505 3.505 0 001.573-.396c.51 1.987.486 3.996.587 6.007.128 2.58 1.007 4.77 4.298 5.404 1.737.335 3.713.011 5.23-.9 3.72-2.233 5.886-5.36 6.378-9.005.38-2.809-1.622-6.154-4.16-7.415-2.7-1.341-5.814-2.252-10.942 1.014a3.505 3.505 0 00-1.127-1.166c1.465-1.435 3.216-2.419 4.908-3.51 2.17-1.402 3.627-3.259 2.53-6.425-.578-1.672-1.846-3.222-3.393-4.08-3.794-2.104-7.586-2.417-10.989-1.021-2.622 1.076-4.518 4.482-4.34 7.31.187 3.008.955 6.161 6.348 8.97a3.505 3.505 0 00-.206.424 3.505 3.505 0 00-.238 1.136c-1.976-.552-3.704-1.577-5.497-2.496-2.298-1.179-4.634-1.513-6.829 1.02-1.158 1.337-1.866 3.21-1.836 4.98.075 4.337 1.7 7.777 4.61 10.026.42.325.9.587 1.415.787zM70.086 41.95a2.689 2.689 0 111.974-5.002 2.689 2.689 0 01-1.974 5.002h0z"
          />
          <Path
            fill="#95C11F"
            d="M6.833 76.98H10.389V81.45700000000001H6.833z"
          />
          <Path
            fill="#95C11F"
            d="M101.992 76.98H105.548V81.45700000000001H101.992z"
          />
          <Path stroke="#95C11F" d="M0 0L29.22 0 29.22 76.532 0 76.532z" />
        </G>
        <G transform="translate(1 1) translate(96.496 66.718)">
          <Circle
            cx={26.375}
            cy={26.375}
            r={26.375}
            fill="#181818"
            stroke="#95C11F"
            strokeWidth={2}
          />
          <Circle cx={26.375} cy={42.281} r={7.131} stroke="#95C11F" />
          <Rect
            width={5.007}
            height={1.113}
            x={37.172}
            y={42.056}
            fill="#95C11F"
            rx={0.556}
          />
          <Rect
            width={5.007}
            height={1.113}
            x={10.571}
            y={42.056}
            fill="#95C11F"
            rx={0.556}
          />
        </G>
        <G transform="translate(1 1) translate(5.177 17.965)">
          <Path
            fill="#FAFAFA"
            d="M71.565 18.715h-4.07c-4.29 0-7.78-3.495-7.78-7.79V.302h.543v10.621c0 3.997 3.246 7.249 7.237 7.249h4.07v.542z"
          />
          <Path fill="#FAFAFA" d="M0 8.251L0.548 8.251 0.548 0.308 0 0.308z" />
          <Path
            fill="#FAFAFA"
            d="M0 18.71h.542v-5.285a3.575 3.575 0 013.57-3.573l5.49-.002a4.118 4.118 0 004.11-4.116V.303h-.542v5.43a3.576 3.576 0 01-3.569 3.575l-5.49.001a4.118 4.118 0 00-4.11 4.116v5.286z"
          />
          <Mask id="b" fill="#fff">
            <Use xlinkHref="#a" />
          </Mask>
          <Path
            fill="#FAFAFA"
            mask="url(#b)"
            d="M13.17 18.713L13.712 18.713 13.712 10.986 13.17 10.986z"
          />
          <Path
            fill="#FAFAFA"
            d="M92.17.562c-4.928 0-8.936 4.014-8.936 8.948 0 4.933 4.008 8.948 8.935 8.948 4.928 0 8.936-4.015 8.936-8.948 0-4.934-4.008-8.948-8.936-8.948m0 18.438c-5.225 0-9.477-4.257-9.477-9.49 0-5.233 4.252-9.49 9.477-9.49 5.226 0 9.478 4.257 9.478 9.49 0 5.233-4.252 9.49-9.478 9.49M28.5 18.712L37.041.727l8.473 17.985h.598L37.406.23a.4.4 0 00-.363-.23h-.001a.4.4 0 00-.365.23L27.9 18.712h.6z"
            mask="url(#b)"
          />
        </G>
      </G>
    </Svg>
  );
}

export function HaloDevices({ width = 288, height = 259 }) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 408 389">
      <G fill="none" fill-rule="evenodd" transform="translate(1.05 1.5)">
        <G stroke="#95C11F" transform="translate(230.897)">
          <Polygon
            stroke-linejoin="round"
            stroke-width="2"
            points="0 6.303 143.709 0 175.005 10.511 175.005 249.514 143.709 272 0 255.734"
          />
          <Line x1="143.709" x2="143.709" y2="272" stroke-linejoin="round" />
          <Polyline
            stroke-linejoin="round"
            points="5.897 6.969 18.913 171.702 18.913 258.238"
          />
          <Polyline
            stroke-linejoin="round"
            points="125.849 0 104.049 181.457 104.049 267.994"
          />
          <Polyline points="143.709 179.851 104.049 185.49 18.913 179.851 0 172.429" />
        </G>
        <G transform="translate(0 103.783)">
          <Rect
            width="211.184"
            height="143.817"
            stroke="#95C11F"
            stroke-width="2"
          />
          <Circle
            cx="134.027"
            cy="71.895"
            r="57.634"
            fill="#181818"
            stroke="#95C11F"
          />
          <Path
            stroke="#95C11F"
            d="M11.3243073,62.026638 C15.5247017,63.6605107 21.03594,63.1356993 24.6410567,60.7426132 C29.3591486,57.6107557 33.7683219,53.3983586 33.272453,41.9861941 C34.3024669,41.9730233 35.3150316,41.7184353 36.22879,41.2428855 C37.186908,44.9762399 37.1425299,48.7511962 37.3308431,52.5303914 C37.5723945,57.37809 39.2243616,61.4940253 45.4084066,62.6853166 C48.6724208,63.3141007 52.3866072,62.7070296 55.2362675,60.9957396 C62.2255207,56.7985352 66.297229,50.9223837 67.2225053,44.0716979 C67.9353327,38.7939589 64.1732403,32.5084666 59.4039654,30.1385088 C54.3321916,27.6182309 48.4789728,25.9059354 38.8421155,32.0434334 C38.3170775,31.1574302 37.5915773,30.4069021 36.7238837,29.8521279 C39.4777962,27.1562445 42.7688141,25.3073817 45.9471366,23.2549625 C50.0245939,20.62192 52.763056,17.133313 50.7027229,11.1821165 C49.6152561,8.04101181 47.2324424,5.12795665 44.3255945,3.51571993 C37.1960811,-0.438546408 30.0713666,-1.0266856 23.6758603,1.59733786 C18.7487979,3.61888176 15.1864081,10.019741 15.5186021,15.3350257 C15.8718633,20.9873814 17.3155315,26.912466 27.4488197,32.1894278 C27.3020235,32.4463233 27.1727053,32.7128188 27.061744,32.9871034 C26.7955087,33.6687289 26.6447298,34.389958 26.6156032,35.1211531 C22.9018711,34.0844623 19.6538347,32.1578434 16.2857195,30.430775 C11.9667138,28.216116 7.57622439,27.5888193 3.45250456,32.3487175 C1.27595719,34.8610401 -0.055415536,38.3811634 0.00177116475,41.7046931 C0.142032306,49.8561618 3.19505923,56.3204111 8.66529114,60.5470725 C9.45545386,61.1576061 10.3549936,61.6495927 11.3243073,62.026638 Z M31.3327391,40.1049183 C30.0863467,39.6129057 29.0864552,38.6459161 28.5530303,37.4166772 C28.0196054,36.1874382 27.9963427,34.7966432 28.4883598,33.5502526 C29.5129154,30.9547922 32.4475112,29.6813143 35.0429781,30.7058535 C36.2893766,31.197853 37.2892789,32.1648328 37.8227167,33.3940672 C38.3561544,34.6233015 38.3794309,36.0140972 37.8874256,37.2604935 C37.395422,38.5068992 36.4284327,39.5068051 35.1991879,40.0402393 C33.9699431,40.5736736 32.579138,40.5969393 31.3327391,40.1049183 L31.3327391,40.1049183 Z"
            transform="translate(100.373 38.727)"
          />
          <Rect
            width="6.681"
            height="8.414"
            x="12.841"
            y="144.659"
            fill="#95C11F"
          />
          <Rect
            width="6.681"
            height="8.414"
            x="191.661"
            y="144.659"
            fill="#95C11F"
          />
          <Polygon
            stroke="#95C11F"
            points="0 0 54.909 0 54.909 143.817 0 143.817"
          />
        </G>
        <G transform="translate(181.334 125.374)">
          <Circle
            cx="49.563"
            cy="49.563"
            r="49.563"
            fill="#181818"
            stroke="#95C11F"
            stroke-width="2"
          />
          <Circle cx="49.563" cy="79.453" r="13.401" stroke="#95C11F" />
          <Rect
            width="9.409"
            height="2.091"
            x="69.854"
            y="79.03"
            fill="#95C11F"
            rx="1.045"
          />
          <Rect
            width="9.409"
            height="2.091"
            x="19.864"
            y="79.03"
            fill="#95C11F"
            rx="1.045"
          />
        </G>
        <Path
          fill="#FFF"
          d="M278.274132,385.686282 L263.496857,385.686282 C247.917845,385.686282 235.243653,372.995211 235.243653,357.394257 L235.243653,318.823122 L237.211705,318.823122 L237.211705,357.394257 C237.211705,371.908225 249.003144,383.716542 263.496857,383.716542 L278.274132,383.716542 L278.274132,385.686282 Z"
        />
        <Polygon
          fill="#FFF"
          points="18.382 347.685 20.372 347.685 20.372 318.841 18.382 318.841"
        />
        <Path
          fill="#FFF"
          d="M18.3831341,385.670248 L20.349499,385.670248 L20.349499,366.475825 C20.349499,359.319269 26.1642006,353.497816 33.312317,353.497816 L53.2494012,353.492753 C61.4811282,353.492753 68.1785842,346.786857 68.1785842,338.543315 L68.1785842,318.82059 L66.2105313,318.82059 L66.2105313,338.543315 C66.2105313,345.699871 60.3958298,351.523012 53.2494012,351.523012 L33.312317,351.528075 C25.08059,351.528075 18.3831341,358.233971 18.3831341,366.475825 L18.3831341,385.670248 Z"
        />
        <Polygon
          fill="#FFF"
          points="66.211 385.68 68.179 385.68 68.179 357.619 66.211 357.619"
        />
        <Path
          fill="#FFF"
          d="M353.102505 319.762251C335.209428 319.762251 320.653264 334.33867 320.653264 352.257065 320.653264 370.173773 335.209428 384.751879 353.102505 384.751879 370.995583 384.751879 385.553435 370.173773 385.553435 352.257065 385.553435 334.33867 370.995583 319.762251 353.102505 319.762251M353.102505 386.72162C334.125818 386.72162 318.685211 371.260759 318.685211 352.257065 318.685211 333.253371 334.125818 317.79251 353.102505 317.79251 372.080881 317.79251 387.5198 333.253371 387.5198 352.257065 387.5198 371.260759 372.080881 386.72162 353.102505 386.72162M121.881953 385.674299 152.899883 320.362288 183.668009 385.674299 185.841982 385.674299 154.224859 318.557958C153.980118 318.043159 153.473758 317.722464 152.904947 317.720776L152.901571 317.720776C152.33276 317.720776 151.8264 318.039783 151.578283 318.557958L119.704604 385.674299 121.881953 385.674299Z"
        />
      </G>
    </Svg>
  );
}

export function Interface(props) {
  return (
    <Svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <G stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <Path
          d="M7.726 17.24h8.548a5.24 5.24 0 000-10.48H7.726a5.24 5.24 0 100 10.48z"
          stroke={props.fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Circle fill={props.fill} cx={8.12221605} cy={12} r={1.43889197} />
        <Circle fill={props.fill} cx={15.8777839} cy={12} r={1.43889197} />
      </G>
    </Svg>
  );
}

export function Holiday(props) {
  return (
    <Svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <Path
        d="M16.244 16.821l-6.456-6.403.63-.63 6.43 6.456-.604.577zM1.942 15.273a9.069 9.069 0 01-1.457-2.755A9.803 9.803 0 010 9.473C0 8.25.232 7.055.695 5.891a9.246 9.246 0 012.087-3.136C3.726 1.828 4.776 1.137 5.93.682A9.655 9.655 0 019.5 0c1.014 0 2.02.157 3.018.472a9.173 9.173 0 012.781 1.444L1.942 15.273zm.052-1.207l2.1-2.1a16.746 16.746 0 01-.866-1.298c-.28-.464-.53-.967-.748-1.51A9.584 9.584 0 011.968 7.4a9.068 9.068 0 01-.157-1.968C1.023 6.832.678 8.292.774 9.815a10.08 10.08 0 001.22 4.25zm2.756-2.677l6.64-6.718a8.912 8.912 0 00-2.363-1.404c-.822-.323-1.605-.529-2.348-.617-.744-.087-1.413-.07-2.008.053-.595.122-1.04.332-1.338.63-.333.332-.556.787-.67 1.364-.113.578-.117 1.234-.013 1.969.105.734.329 1.509.67 2.322.34.814.818 1.614 1.43 2.401zm7.295-7.321l2.1-2.074C12.798 1.172 11.359.734 9.828.682 8.297.63 6.84.988 5.458 1.758a8.578 8.578 0 011.93.158c.603.122 1.18.297 1.731.525a11.62 11.62 0 011.549.774c.48.288.94.573 1.377.853z"
        transform="translate(3.576 3.57)"
        fill={props.fill}
        fillRule="nonzero"
        stroke="none"
        strokeWidth={1}
      />
    </Svg>
  );
}

export const Fire = props => {
  return (
    <Svg width="15" height="21" viewBox="0 0 15 21" {...props}>
      <G
        fill={props.fill ? props.fill : '#EF4444'}
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
        transform="translate(-343.78 -95)">
        <Path d="M353.05814,95 C346.87193,99.5579767 343.77907,103.953326 343.77907,108.186047 C343.77907,114.44307 347.573721,115.955558 351.423558,115.998047 C348.926512,115.977047 346.456814,115.008116 346.456814,110.949744 C346.456814,108.214372 348.455721,105.374 352.453535,102.42814 C352.434488,103.374116 352.644977,104.32107 353.085,105.268512 C353.744791,106.689674 356.24086,107.793884 356.24086,110.949744 C356.24086,114.098767 354.041721,115.990233 351.524163,115.999023 C351.547116,115.999023 351.57007,116 351.593023,116 C355.5,116 358.918605,113.069767 358.918605,108.186047 C358.918605,103.302326 355.05607,101.594488 354.034884,99.3953488 C353.354093,97.9292558 353.028837,96.4641395 353.05814,95" />
      </G>
    </Svg>
  );
};

export const HeatPump = props => {
  return (
    <Svg viewBox="0 0 21 19" {...props}>
      <G
        id="heatpump-Icon"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd">
        <G
          id="Icon-/-heat_pump"
          transform="translate(-2.000000, -3.000000)"
          stroke={props.stroke ? props.stroke : '#000'}>
          <G id="Group" transform="translate(3.279331, 4.477337)">
            <Circle
              id="Oval"
              stroke-width="0.5"
              cx="8.72066861"
              cy="7.50947519"
              r="2.30381813"
            />
            <Path
              d="M10.7683061,6.56442592 C12.0706948,5.20146722 12.6713813,4.01870131 12.5703655,3.01612819 C12.4188419,1.5122685 10.6750605,0 7.82835683,0 C4.98165313,0 2.81448597,2.50238896 2.95018124,3.28221296 C3.0858765,4.06203696 3.67260391,4.17464919 5.0535403,4.58264182 C5.97416456,4.85463691 6.62958533,5.32891082 7.01980262,6.00546357"
              id="Path-2"
            />
            <Path
              d="M8.25736127,13.873259 C9.55974995,12.5103003 10.1604364,11.3275344 10.0594207,10.3249612 C9.90789703,8.82110155 8.16411566,7.30883305 5.31741196,7.30883305 C2.47070826,7.30883305 0.303541094,9.81122201 0.43923636,10.591046 C0.574931626,11.37087 1.16165903,11.4834822 2.54259542,11.8914749 C3.46321968,12.16347 4.11864045,12.6377439 4.50885774,13.3142966"
              id="Path-2-Copy"
              transform="translate(5.251762, 10.591046) rotate(-120.000000) translate(-5.251762, -10.591046) "
            />
            <Path
              d="M15.8478378,12.5439345 C17.1502265,11.1809758 17.7509129,9.99820989 17.6498972,8.99563677 C17.4983736,7.49177708 15.7545922,5.97950858 12.9078885,5.97950858 C10.0611848,5.97950858 7.89401762,8.48189754 8.02971289,9.26172154 C8.16540816,10.0415455 8.75213556,10.1541578 10.133072,10.5621504 C11.0536962,10.8341455 11.709117,11.3084194 12.0993343,11.9849721"
              id="Path-2"
              transform="translate(12.842239, 9.261722) rotate(127.000000) translate(-12.842239, -9.261722) "
            />
          </G>
        </G>
      </G>
    </Svg>
  );
};

export function Info(props) {
  return (
    <Svg width={24} height={24} viewBox="0 0 48 48" {...props}>
      <Path
        fill={props.fill ? props.fill : '#ffffff'}
        d="M22.65 34h3V22h-3ZM24 18.3q.7 0 1.175-.45.475-.45.475-1.15t-.475-1.2Q24.7 15 24 15q-.7 0-1.175.5-.475.5-.475 1.2t.475 1.15q.475.45 1.175.45ZM24 44q-4.1 0-7.75-1.575-3.65-1.575-6.375-4.3-2.725-2.725-4.3-6.375Q4 28.1 4 23.95q0-4.1 1.575-7.75 1.575-3.65 4.3-6.35 2.725-2.7 6.375-4.275Q19.9 4 24.05 4q4.1 0 7.75 1.575 3.65 1.575 6.35 4.275 2.7 2.7 4.275 6.35Q44 19.85 44 24q0 4.1-1.575 7.75-1.575 3.65-4.275 6.375t-6.35 4.3Q28.15 44 24 44Zm.05-3q7.05 0 12-4.975T41 23.95q0-7.05-4.95-12T24 7q-7.05 0-12.025 4.95Q7 16.9 7 24q0 7.05 4.975 12.025Q16.95 41 24.05 41ZM24 24Z"
      />
    </Svg>
  );
}

export const InfoLarge = props => (
  <Svg width={48} height={48} viewBox="0 0 48 48" {...props}>
    <Path
      fill={props.fill ? props.fill : '#ffffff'}
      d="M22.65 34h3V22h-3ZM24 18.3q.7 0 1.175-.45.475-.45.475-1.15t-.475-1.2Q24.7 15 24 15q-.7 0-1.175.5-.475.5-.475 1.2t.475 1.15q.475.45 1.175.45ZM24 44q-4.1 0-7.75-1.575-3.65-1.575-6.375-4.3-2.725-2.725-4.3-6.375Q4 28.1 4 23.95q0-4.1 1.575-7.75 1.575-3.65 4.3-6.35 2.725-2.7 6.375-4.275Q19.9 4 24.05 4q4.1 0 7.75 1.575 3.65 1.575 6.35 4.275 2.7 2.7 4.275 6.35Q44 19.85 44 24q0 4.1-1.575 7.75-1.575 3.65-4.275 6.375t-6.35 4.3Q28.15 44 24 44Zm.05-3q7.05 0 12-4.975T41 23.95q0-7.05-4.95-12T24 7q-7.05 0-12.025 4.95Q7 16.9 7 24q0 7.05 4.975 12.025Q16.95 41 24.05 41ZM24 24Z"
    />
  </Svg>
);

export const Boiler = props => {
  return (
    <Svg viewBox="7 3 10 18" {...props}>
      <G
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1">
        <G
          stroke={props.stroke ? props.stroke : '#181818'}
          transform="translate(7.674 4.423)">
          <Path d="M2.64877328 10.4582637L3.3842681 10.8375351 5.27333154 10.8375351 6.00824286 10.4582637z" />
          <Path d="M0.0335509337 10.0594452L1.40184554 10.4276302 7.25517061 10.4276302 8.60012543 10.0594452" />
          <Path d="M0 15.1238857L0.0064184395 0.161044482 0.981437749 0.161044482 0.981437749 0 7.67645364 0 7.67645364 0.161044482 8.65147295 0.161044482 8.65147295 15.1238857z" />
        </G>
      </G>
    </Svg>
  );
};

const renderDisplayNumber = numOfNotfication => {
  if (numOfNotfication !== null && numOfNotfication > 0) {
    return (
      <View style={styles.notificationCount}>
        <Svg width={18} height={18}>
          <G>
            <Circle r="9" cx="50%" cy="50%" fill={accent(500)} />
            <Text
              x="50%"
              y="50%"
              textAnchor="middle"
              fill="black"
              fontFamily="Montserrat-Regular, Montserrat"
              dy="0.3em">
              {numOfNotfication}
            </Text>
          </G>
        </Svg>
      </View>
    );
  }
};
export const NotificationBell = props => {
  const numOfNotfication = props.numOfNotfication || 0;
  const disabled = props.disabled || false;

  return (
    <View style={styles.notificationBellContainer}>
      <Svg height={24} width={24}>
        <Path
          fill={disabled ? primary(900) : primary(50)}
          d="M4.5 18.725v-1h2v-7.5q0-2 1.275-3.513Q9.05 5.2 11 4.825v-.7q0-.45.288-.725.287-.275.712-.275t.713.275q.287.275.287.725v.7q1.95.375 3.225 1.887Q17.5 8.225 17.5 10.225v7.5h2v1zm7.5-7zm0 9.9q-.65 0-1.137-.462-.488-.463-.488-1.163h3.25q0 .7-.462 1.163-.463.462-1.163.462zm-4.5-3.9h9v-7.5q0-1.875-1.312-3.188Q13.875 5.725 12 5.725q-1.875 0-3.188 1.312Q7.5 8.35 7.5 10.225z"
        />
      </Svg>
      {renderDisplayNumber(numOfNotfication)}
    </View>
  );
};

export const DownArrow = props => {
  const { style, disabled } = props;

  return (
    <Svg
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke={disabled ? 'grey' : '#FFFFFF'}
      fill="none"
      style={style}
      {...props}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </Svg>
  );
};

export const UpArrow = props => {
  const { style, disabled } = props;

  return (
    <Svg
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke={disabled ? 'grey' : '#FFFFFF'}
      fill="none"
      style={style}
      {...props}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4.5 15.75l7.5-7.5 7.5 7.5"
      />
    </Svg>
  );
};

export const ChevronUp = props => {
  const { style, disabled } = props;

  return (
    <Svg
      height={24}
      width={24}
      style={[{ transform: [{ rotate: '90deg' }], style }]}
      {...props}>
      <Path
        fill={disabled ? 'grey' : '#FFFFFF'}
        d="M16 21.3L6.7 12 16 2.7l1.075 1.05L8.825 12l8.25 8.25z"
      />
    </Svg>
  );
};

export const ChevronDown = props => {
  const { style, disabled } = props;

  return (
    <Svg
      height={24}
      width={24}
      style={[{ transform: [{ rotate: '270deg' }], style }]}
      {...props}>
      <Path
        fill={disabled ? 'grey' : '#FFFFFF'}
        d="M16 21.3L6.7 12 16 2.7l1.075 1.05L8.825 12l8.25 8.25z"
      />
    </Svg>
  );
};

export const ChevronLeft = props => (
  <Svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <Path
      fill="#FFFFFF"
      d="M16 21.3L6.7 12 16 2.7l1.075 1.05L8.825 12l8.25 8.25z"
    />
  </Svg>
);

export const ChevronRight = props => {
  const { style, disabled } = props;

  return (
    <Svg
      height={24}
      width={24}
      style={[{ transform: [{ rotate: '180deg' }], style }]}
      {...props}>
      <Path
        fill={disabled ? 'grey' : '#FFFFFF'}
        d="M16 21.3L6.7 12 16 2.7l1.075 1.05L8.825 12l8.25 8.25z"
      />
    </Svg>
  );
};

export const DropUp = ({ height, width, style, fill = '#FFFFFF' }) => (
  <Svg
    width={width || 24}
    height={height || 24}
    viewBox="0 0 48 48"
    style={[{ transform: [{ rotate: '-90deg' }], style }]}>
    <Path
      transform="rotate(180 12 24)"
      fill={fill}
      d="M20 44L0 24 20 4l2.8 2.85L5.65 24 22.8 41.15z"
    />
  </Svg>
);

export const DropDown = ({ height, width, style, fill = '#FFFFFF' }) => (
  <Svg
    width={width || 24}
    height={height || 24}
    viewBox="0 0 48 48"
    style={[{ transform: [{ rotate: '-90deg' }] }, style]}>
    <Path fill={fill} d="M20 44L0 24 20 4l2.8 2.85L5.65 24 22.8 41.15z" />
  </Svg>
);

export const Copy = () => (
  <Svg width={24} height={24} viewBox="0 0 48 48">
    <Path
      fill="#FFFFFF"
      d="M9 43.95q-1.2 0-2.1-.9-.9-.9-.9-2.1V10.8h3v30.15h23.7v3zm6-6q-1.2 0-2.1-.9-.9-.9-.9-2.1v-28q0-1.2.9-2.1.9-.9 2.1-.9h22q1.2 0 2.1.9.9.9.9 2.1v28q0 1.2-.9 2.1-.9.9-2.1.9zm0-3h22v-28H15v28zm0 0v-28 28z"
    />
  </Svg>
);

export const Schedule = ({ height = 24, width = 24, fill }) => (
  <Svg height={height} width={width} viewBox="0 0 48 48">
    <Path
      fill={fill ? fill : '#000'}
      d="M28.8 43v-2.25h9.3q.25 0 .45-.2t.2-.45V20.25H9.25v10.1H7v-19.2q0-1.15.85-2.025T9.9 8.25h3.7v-3.5h2.5v3.5H32v-3.5h2.45v3.5h3.65q1.2 0 2.05.875Q41 10 41 11.15V40.1q0 1.2-.85 2.05-.85.85-2.05.85ZM16 46.8l-1.6-1.6 6-6.05H2.85v-2.3H20.4l-6-6.05 1.6-1.6 8.8 8.8ZM9.25 18h29.5v-6.85q0-.25-.2-.425t-.45-.175H9.9q-.25 0-.45.175t-.2.425Zm0 0V10.55 18Z"
    />
  </Svg>
);

export const FailCircle = ({ height = 24, width = 24, fill }) => (
  <Svg height={height} width={width} viewBox="0 96 960 960">
    <Path
      fill={fill ? fill : '#000'}
      d="M479.982 776q14.018 0 23.518-9.482 9.5-9.483 9.5-23.5 0-14.018-9.482-23.518-9.483-9.5-23.5-9.5-14.018 0-23.518 9.482-9.5 9.483-9.5 23.5 0 14.018 9.482 23.518 9.483 9.5 23.5 9.5ZM453 623h60V370h-60v253Zm27.266 353q-82.734 0-155.5-31.5t-127.266-86q-54.5-54.5-86-127.341Q80 658.319 80 575.5q0-82.819 31.5-155.659Q143 347 197.5 293t127.341-85.5Q397.681 176 480.5 176q82.819 0 155.659 31.5Q709 239 763 293t85.5 127Q880 493 880 575.734q0 82.734-31.5 155.5T763 858.316q-54 54.316-127 86Q563 976 480.266 976Zm.234-60Q622 916 721 816.5t99-241Q820 434 721.188 335 622.375 236 480 236q-141 0-240.5 98.812Q140 433.625 140 576q0 141 99.5 240.5t241 99.5Zm-.5-340Z"
    />
  </Svg>
);

export const Clock = style => (
  <Svg width={24} height={24} viewBox="0 0 48 48">
    <Path
      fill={style.fill ? style.fill : '#000'}
      d="M22 41q-3.55 0-6.65-1.35-3.1-1.35-5.375-3.625T6.35 30.65Q5 27.55 5 24q0-3.55 1.35-6.65 1.35-3.1 3.65-5.375t5.4-3.625Q18.5 7 22.05 7q1.2 0 2.45.175 1.25.175 2.5.525v2.45q-1.2-.45-2.45-.675-1.25-.225-2.5-.225-6.15 0-10.475 4.325Q7.25 17.9 7.25 24q0 6.1 4.325 10.425Q15.9 38.75 22 38.75q6.1 0 10.425-4.325Q36.75 30.1 36.75 24q0-.7-.075-1.475-.075-.775-.275-1.725h2.3q.15.75.225 1.6.075.85.075 1.6 0 3.55-1.35 6.65-1.35 3.1-3.625 5.375T28.65 39.65Q25.55 41 22 41Zm6.1-9-7.45-7.4V14h2.25v9.65l6.8 6.75Zm8.4-14.45V11.4h-6.2V9.1h6.2V2.9h2.3v6.2H45v2.3h-6.2v6.15Z"
    />
  </Svg>
);

// A thermometer reading half way: an outlined stem with a mercury column
// filling its lower half, graduation marks up the right side, and a filled
// bulb drawn last so it covers where the stem outline meets it. Built from
// primitives like [Thermostat] — Heroicons has no thermometer.
export const Thermometer = props => {
  const c = props?.fill || '#000';

  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <Rect
        x={8.8}
        y={1.5}
        width={3.8}
        height={15.5}
        rx={1.9}
        stroke={c}
        strokeWidth={1.5}
        fill="none"
      />
      <Rect fill={c} x={9.9} y={9} width={1.6} height={10} rx={0.8} />
      {[4.5, 8.5, 12.5].map(y => (
        <Rect
          key={y}
          fill={c}
          x={14.75}
          y={y}
          width={3.25}
          height={1.3}
          rx={0.65}
        />
      ))}
      {/* Wider than the stem's outer edge, so it covers the outline's foot */}
      <Circle fill={c} cx={10.7} cy={19} r={3.2} />
    </Svg>
  );
};

export const Lock = style => (
  <Svg width={20} height={20} viewBox="0 0 48 48">
    <Path
      fill={style.fill ? style.fill : '#000'}
      d="M11 44q-1.25 0-2.125-.875T8 41V19.3q0-1.25.875-2.125T11 16.3h3.5v-4.8q0-3.95 2.775-6.725Q20.05 2 24 2q3.95 0 6.725 2.775Q33.5 7.55 33.5 11.5v4.8H37q1.25 0 2.125.875T40 19.3V41q0 1.25-.875 2.125T37 44Zm0-3h26V19.3H11V41Zm13-7q1.6 0 2.725-1.1t1.125-2.65q0-1.5-1.125-2.725T24 26.3q-1.6 0-2.725 1.225T20.15 30.25q0 1.55 1.125 2.65Q22.4 34 24 34Zm-6.5-17.7h13v-4.8q0-2.7-1.9-4.6Q26.7 5 24 5q-2.7 0-4.6 1.9-1.9 1.9-1.9 4.6ZM11 41V19.3 41Z"
    />
  </Svg>
);

export const Snowflake = props => {
  return (
    <Svg viewBox="0 0 24 24" {...props}>
      <Path d="M11.5 21.5v-4.85l-3.75 3.7-.7-.7 4.45-4.45v-2.7H8.8l-4.45 4.45-.7-.7 3.7-3.75H2.5v-1h4.85l-3.7-3.75.7-.7L8.8 11.5h2.7V8.8L7.05 4.35l.7-.7 3.75 3.7V2.5h1v4.85l3.75-3.7.7.7L12.5 8.8v2.7h2.7l4.45-4.45.7.7-3.7 3.75h4.85v1h-4.85l3.7 3.75-.7.7-4.45-4.45h-2.7v2.7l4.45 4.45-.7.7-3.75-3.7v4.85z" />
    </Svg>
  );
};

export const PlusHours = props => {
  return (
    <Svg viewBox="0 0 24 24" {...props}>
      <Path d="M11 20q-1.675 0-3.125-.625t-2.537-1.712q-1.088-1.088-1.713-2.538Q3 13.675 3 12t.625-3.125q.625-1.45 1.713-2.537Q6.425 5.25 7.875 4.625T11 4q.525 0 1.012.062.488.063.988.188V5.3q-.5-.15-.988-.225Q11.525 5 11 5 8.1 5 6.05 7.05 4 9.1 4 12q0 2.9 2.05 4.95Q8.1 19 11 19q2.9 0 4.95-2.05Q18 14.9 18 12q0-.275-.025-.562-.025-.288-.1-.563H18.9q.05.25.075.55.025.3.025.575 0 1.675-.625 3.125t-1.712 2.538q-1.088 1.087-2.538 1.712Q12.675 20 11 20zm3.15-4.15L10.5 12.2V7h1v4.8l3.35 3.35zM18 8.875v-3h-3v-1h3v-3h1v3h3v1h-3v3z" />
    </Svg>
  );
};

export const Menu = ({ fill = '#FFFFFF', ...props }) => {
  return (
    <Svg height={24} width={24} {...props}>
      <Path
        fill={fill}
        d="M3.5 17.275v-1h17v1zm0-4.775v-1h17v1zm0-4.775v-1h17v1z"
      />
    </Svg>
  );
};

export const SupervisorAccount = props => {
  return (
    <Svg height={24} width={24} viewBox="0 0 24 24" fill="none" {...props}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10.13 10.827c-.97 0-1.781-.321-2.434-.964-.653-.643-.98-1.46-.98-2.45 0-.969.327-1.78.98-2.433C8.349 4.327 9.16 4 10.13 4c.99 0 1.806.327 2.449.98.643.653.965 1.464.965 2.434 0 .99-.322 1.806-.965 2.449-.643.643-1.46.964-2.449.964Zm-8.282 8.55v-1.692c0-.535.139-1 .416-1.396.277-.395.682-.712 1.217-.95 1.167-.534 2.246-.93 3.235-1.187.99-.257 2.128-.386 3.414-.386h.267c.08 0 .158-.01.238-.03-.06.159-.104.307-.134.446-.03.138-.054.297-.074.475h-.297c-1.207 0-2.29.109-3.25.326-.96.218-1.955.594-2.984 1.128-.455.238-.762.48-.92.728-.158.247-.237.529-.237.846v.801h7.718c.02.158.064.317.133.475.07.158.134.297.193.416H1.848Zm16.03.623-.149-1.455a3.316 3.316 0 0 1-1.098-.385 3.211 3.211 0 0 1-.89-.713l-1.247.416-.297-.475 1.098-.89c-.119-.278-.178-.614-.178-1.01s.06-.752.178-1.069l-1.069-.89.297-.475 1.217.445c.218-.317.51-.569.876-.757a3.689 3.689 0 0 1 1.113-.37l.149-1.455h.623l.119 1.454c.376.08.747.213 1.113.4.366.189.668.421.905.698l1.188-.415.297.445-1.07.92c.12.317.179.668.179 1.054s-.06.727-.178 1.024l1.098.89-.297.476-1.217-.416a3.687 3.687 0 0 1-.92.713 3.316 3.316 0 0 1-1.098.385L18.5 20h-.623Zm.267-2.375c.633 0 1.153-.203 1.558-.608.406-.406.609-.925.609-1.559 0-.633-.203-1.148-.609-1.543-.405-.396-.925-.594-1.558-.594-.614 0-1.123.198-1.529.594-.406.395-.608.92-.608 1.573 0 .613.202 1.123.608 1.529.406.405.915.608 1.529.608ZM10.13 9.937c.712 0 1.311-.238 1.796-.713.485-.474.727-1.078.727-1.81 0-.713-.242-1.311-.727-1.796-.485-.485-1.084-.727-1.796-.727s-1.311.242-1.796.727c-.485.485-.727 1.083-.727 1.796 0 .732.242 1.336.727 1.81.485.475 1.084.713 1.796.713Z"
      />
    </Svg>
  );
};

export const Home = props => {
  return (
    <Svg
      height={18}
      width={18}
      viewBox="0 0 22 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M0 24.048V8.028L10.705 0l10.628 8.067v15.98h-7.722v-9.901H7.76v9.902H0zM1.147 22.9h5.467v-9.902h8.143V22.9h5.43V8.602l-9.482-7.111-9.558 7.111v14.299z"
        transform="translate(-13 -12) translate(13.333 11.976)"
        fillRule="nonzero"
        stroke="none"
        strokeWidth={1}
      />
    </Svg>
  );
};

export function Geolocation(props) {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 23" {...props}>
      <G fill="none" fill-rule="evenodd" transform="translate(2.968 .75)">
        <Path
          stroke="#FAFAFA"
          stroke-linejoin="round"
          d="M23.03,22.4142478 C21.3518584,21.1393805 20.1030088,19.9165487 19.2834513,18.7457522 C18.4638938,17.5749558 18.054115,16.430177 18.054115,15.3114159 C18.054115,14.4788496 18.2037168,13.7438496 18.5029204,13.1064159 C18.8021239,12.4689823 19.185885,11.9356195 19.6542035,11.5063274 C20.1225221,11.0770354 20.6602212,10.7539823 21.2651327,10.5393363 C21.8700442,10.3246903 22.4597788,10.2162832 23.0321681,10.2162832 C23.6045575,10.2162832 24.194292,10.3246903 24.7992035,10.5393363 C25.404115,10.7539823 25.9418142,11.0770354 26.4101327,11.5063274 C26.8784513,11.9356195 27.2665487,12.4689823 27.5722566,13.1064159 C27.8779646,13.7438496 28.0319027,14.4788496 28.0319027,15.3114159 C28.0319027,16.430177 27.6177876,17.5749558 26.7917257,18.7457522 C25.9656637,19.9165487 24.7124779,21.1393805 23.0343363,22.4142478 L23.03,22.4142478 Z"
        />
        <Path
          stroke="#CAE08F"
          d="M23.0495133,16.2653982 C23.3487168,16.2653982 23.6023894,16.1613274 23.810531,15.9531858 C24.0186726,15.7450442 24.1227434,15.4913717 24.1227434,15.1921681 C24.1227434,14.8929646 24.0143363,14.639292 23.7996903,14.4311504 C23.5850442,14.2230088 23.3270354,14.1189381 23.0278319,14.1189381 C22.7286283,14.1189381 22.4749558,14.2230088 22.2668142,14.4311504 C22.0586726,14.639292 21.9546018,14.8929646 21.9546018,15.1921681 C21.9546018,15.4913717 22.0630088,15.7450442 22.2776549,15.9531858 C22.4923009,16.1613274 22.7503097,16.2653982 23.0495133,16.2653982 Z"
        />
        <Polyline
          stroke="#CAE08F"
          stroke-linecap="round"
          stroke-linejoin="round"
          points="22.982 8.889 22.982 8.239 11.491 0 0 8.239 0 24.5 8.673 24.5 8.673 15.827 14.31 15.827 14.31 24.5 22.982 24.5 22.982 23.85"
        />
      </G>
    </Svg>
  );
}

export const Close = props => {
  return (
    <Svg
      height={props.height || 24}
      width={props.width || 24}
      {...props}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg">
      <Path
        fill={props.fill || '#FFFFFF'}
        d="M6.4 18.3l-.7-.7 5.6-5.6-5.6-5.6.7-.7 5.6 5.6 5.6-5.6.7.7-5.6 5.6 5.6 5.6-.7.7-5.6-5.6z"
      />
    </Svg>
  );
};

export const AutoMode = props => {
  return (
    <Svg height={24} width={24} {...props}>
      <Path d="M7.275 16.825h1.45L9.75 14h4.5l1.025 2.825h1.45l-3.95-10.65h-1.5Zm2.9-4.05 1.8-4.925h.1l1.75 4.925ZM12 21.5q-1.975 0-3.712-.75Q6.55 20 5.275 18.725T3.25 15.712Q2.5 13.975 2.5 12t.75-3.713Q4 6.55 5.275 5.275T8.288 3.25Q10.025 2.5 12 2.5t3.713.75q1.737.75 3.012 2.025t2.025 3.012q.75 1.738.75 3.713t-.75 3.712q-.75 1.738-2.025 3.013t-3.012 2.025q-1.738.75-3.713.75Zm0-9.5Zm0 8q3.325 0 5.663-2.337Q20 15.325 20 12t-2.337-5.663Q15.325 4 12 4T6.338 6.337Q4 8.675 4 12t2.338 5.663Q8.675 20 12 20Z" />
    </Svg>
  );
};

export const ManualMode = props => {
  return (
    <Svg height={24} width={24} {...props}>
      <Path d="M11.575 1.5q2.075 0 3.538 1.45 1.462 1.45 1.462 3.525 0 1.3-.65 2.425-.65 1.125-1.825 1.8h-.525V9.225q.675-.45 1.088-1.163.412-.712.412-1.587 0-1.425-1.037-2.45Q13 3 11.575 3 10.125 3 9.1 4.025 8.075 5.05 8.075 6.475q0 .9.413 1.638.412.737 1.087 1.162v1.8q-1.325-.575-2.163-1.8-.837-1.225-.837-2.8 0-2.075 1.462-3.525Q9.5 1.5 11.575 1.5Zm-.95 20q-.325 0-.6-.125-.275-.125-.5-.35l-4.8-4.775 1.075-1.1q.25-.25.563-.388.312-.137.637-.037l2.575.55V6.5q0-.85.575-1.425.575-.575 1.425-.575.85 0 1.425.575.575.575.575 1.425v4.675h.8q.125 0 .225.037.1.038.2.113L18.25 13q.65.3.938.987.287.688.162 1.388l-.825 4.9q-.1.525-.525.875-.425.35-.975.35Zm0-1.5h6.4l.85-4.9q.05-.2-.012-.412-.063-.213-.288-.338l-3.75-1.85h-1.75v-6q0-.225-.137-.363Q11.8 6 11.575 6q-.225 0-.362.137-.138.138-.138.363v10.6l-4.25-.875Zm6.4 0h-6.4 6.4Z" />
    </Svg>
  );
};

export const OffMode = props => {
  return (
    <Svg height={24} width={24} {...props}>
      <Path d="M11.25 13V3.425h1.5V13Zm.75 7.5q-1.75 0-3.3-.675Q7.15 19.15 6 18q-1.15-1.15-1.825-2.7Q3.5 13.75 3.5 12q0-1.9.8-3.575.8-1.675 2.225-2.9L7.55 6.55q-1.2 1-1.875 2.425Q5 10.4 5 12q0 2.9 2.05 4.95Q9.1 19 12 19q2.925 0 4.962-2.05Q19 14.9 19 12q0-1.6-.663-3.025-.662-1.425-1.887-2.425l1.025-1.025q1.45 1.225 2.237 2.9Q20.5 10.1 20.5 12q0 1.75-.675 3.3Q19.15 16.85 18 18q-1.15 1.15-2.688 1.825-1.537.675-3.312.675Z" />
    </Svg>
  );
};

export const Success = props => {
  return (
    <Svg
      width="110px"
      height="110px"
      viewBox="0 0 110 110"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <G
        transform="translate(-1 -1) translate(1.889 1.889)"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd">
        <Circle fill="#666" cx={54.1843091} cy={54.2429105} r={40} />
        <Path
          d="M102.512 46.351a2.646 2.646 0 015.225-.829c.238 1.477.418 2.926.532 4.34.117 1.457.177 2.912.177 4.361 0 14.97-6.068 28.528-15.881 38.342-9.813 9.812-23.366 15.881-38.342 15.881-14.97 0-28.528-6.068-38.342-15.881C6.07 82.752 0 69.199 0 54.223c0-14.97 6.068-28.528 15.881-38.342C25.694 6.07 39.247 0 54.223 0c5.803 0 11.407.92 16.675 2.625a54.033 54.033 0 0115.063 7.641 2.65 2.65 0 11-3.11 4.293 48.748 48.748 0 00-13.569-6.893 48.92 48.92 0 00-15.06-2.356c-13.507 0-25.735 5.474-34.585 14.327-8.85 8.85-14.326 21.078-14.326 34.586s5.476 25.736 14.326 34.586c8.85 8.853 21.078 14.326 34.586 14.326s25.736-5.473 34.586-14.326c8.853-8.85 14.326-21.078 14.326-34.586a49.88 49.88 0 00-.623-7.875v.003zM27.07 49.203a2.644 2.644 0 114.17-3.256L51.742 72.23l46.4-55.207a2.64 2.64 0 013.72-.322 2.643 2.643 0 01.322 3.723L53.77 78.03a2.644 2.644 0 01-4.19.028l-22.511-28.85.001-.005z"
          fill="#B5D462"
          fillRule="nonzero"
        />
      </G>
    </Svg>
  );
};

export const Failure = props => {
  return (
    <Svg
      width="154px"
      height="154px"
      viewBox="0 0 154 154"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <G
        transform="translate(21 21) translate(-20.49 -20.49)"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd">
        <Circle fill="#666" cx={76.4901466} cy={76.4903118} r={40} />
        <Path
          d="M99.927 37.208a2.64 2.64 0 014.961-1.807 55.291 55.291 0 011.347 4.15 54.376 54.376 0 011.004 4.239c2.85 14.665-.513 29.101-8.257 40.583-7.744 11.481-19.865 20.007-34.536 22.859-14.665 2.85-29.101-.512-40.583-8.257C12.382 91.231 3.856 79.11 1.004 64.44c-2.85-14.666.512-29.102 8.257-40.584C17.005 12.375 29.126 3.849 43.796.997A53.973 53.973 0 0160.631.394a53.921 53.921 0 0116.21 4.617 2.645 2.645 0 11-2.23 4.798 48.648 48.648 0 00-14.602-4.17 48.819 48.819 0 00-15.201.56c-13.233 2.573-24.17 10.263-31.153 20.62C6.67 37.174 3.635 50.196 6.206 63.43 8.78 76.66 16.472 87.595 26.826 94.58c10.355 6.987 23.377 10.02 36.609 7.448 13.232-2.572 24.169-10.262 31.153-20.62 6.987-10.355 10.02-23.376 7.448-36.608a49.777 49.777 0 00-2.11-7.595v.002z"
          transform="rotate(-47 91.032 39.582)"
          fill="#B5D462"
          fillRule="nonzero"
        />
        <Path
          stroke="#B5D462"
          strokeWidth={5}
          strokeLinecap="round"
          transform="rotate(-40 76.552 53.985)"
          d="M92.938229 34.4539118L60.1743532 73.4069867"
        />
        <Path
          stroke="#B5D462"
          strokeWidth={5}
          strokeLinecap="round"
          transform="rotate(-40 76.49 94.49)"
          d="M77.7757218 92.9582229L75.2045714 96.0224006"
        />
      </G>
    </Svg>
  );
};

export const Information = props => {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={112}
      height={112}
      viewBox="0 0 112 112"
      {...props}>
      <G fill="none" fillRule="evenodd">
        <Circle cx={56} cy={56} r={40} fill="#666" />
        <Path
          fill="#B5D462"
          fillRule="nonzero"
          d="M74.872 10.968a2.64 2.64 0 012.062-4.86 55.291 55.291 0 013.954 1.845 54.376 54.376 0 013.784 2.156c12.67 7.917 20.934 20.222 24.05 33.717 3.115 13.493 1.084 28.173-6.835 40.847-7.917 12.67-20.222 20.934-33.717 24.05-13.494 3.115-28.173 1.084-40.847-6.836C14.653 93.97 6.389 81.665 3.273 68.17.158 54.677 2.189 39.997 10.108 27.323A53.973 53.973 0 0121.148 14.6a53.921 53.921 0 0114.433-8.707 2.645 2.645 0 111.988 4.903 48.648 48.648 0 00-13.009 7.836 48.819 48.819 0 00-9.957 11.5C7.459 41.563 5.625 54.807 8.437 66.978c2.81 12.17 10.262 23.271 21.694 30.415 11.432 7.143 24.677 8.974 36.846 6.165C79.15 100.75 90.25 93.296 97.392 81.864c7.143-11.432 8.978-24.675 6.166-36.846-2.808-12.173-10.263-23.272-21.695-30.415a49.777 49.777 0 00-6.993-3.636h.002z"
        />
        <G
          stroke="#B5D462"
          strokeLinecap="round"
          strokeWidth={5}
          transform="matrix(1 0 0 -1 30.299 75.246)">
          <Path
            transform="rotate(-40 25.732 26.123)"
            d="M42.546 6.131L8.917 46.115"
          />
          <Path
            transform="rotate(-40 26.105 66.925)"
            d="M25.105 67.489L26.384 66.012"
          />
        </G>
      </G>
    </Svg>
  );
};

export function Data(props) {
  return (
    <Svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <Path
        d="M0 17.875v-1.347l.825-.825v2.172H0zm4.455 0v-5.747l.853-.825v6.572h-.853zm4.455 0v-6.572l.853.852v5.72H8.91zm4.483 0v-5.72l.825-.825v6.545h-.825zm4.455 0V7.728l.825-.825v10.972h-.825zM0 11.028V9.873L7.123 2.75l4.4 4.4L18.673 0v1.183l-7.15 7.122-4.4-4.4L0 11.028z"
        transform="translate(2.664 3.062)"
        fill={props.fill}
        fillRule="nonzero"
        stroke="none"
        strokeWidth={1}
      />
    </Svg>
  );
}

export function Settings(props) {
  return (
    <Svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <Path
        d="M7.193 18.38l-.41-2.918a7.592 7.592 0 01-1.215-.55 6.265 6.265 0 01-1.19-.832L1.69 15.308 0 12.288l2.406-1.767a8.83 8.83 0 01-.102-1.305c0-.188.008-.397.026-.627.017-.23.042-.474.076-.73L0 6.041l1.69-2.943 2.688 1.177a9.351 9.351 0 011.151-.78 5.68 5.68 0 011.255-.551L7.194 0h3.379l.435 2.944c.41.154.81.341 1.203.563.392.222.76.478 1.1.768l2.791-1.177 1.69 2.943-2.51 1.844c.052.239.09.465.116.678.026.213.038.422.038.627 0 .17-.012.367-.038.589-.026.222-.064.46-.115.717l2.457 1.792-1.69 3.02-2.738-1.254c-.359.324-.73.606-1.114.845-.384.239-.78.418-1.19.537l-.435 2.944h-3.38zm1.639-6.758c.682 0 1.258-.235 1.728-.704.47-.47.704-1.045.704-1.728 0-.682-.235-1.258-.704-1.728-.47-.47-1.046-.704-1.728-.704-.683 0-1.259.235-1.728.704-.47.47-.704 1.046-.704 1.728 0 .683.235 1.259.704 1.728.47.47 1.045.704 1.728.704zm0-.768c-.461 0-.854-.162-1.178-.486a1.604 1.604 0 01-.486-1.178c0-.46.162-.853.486-1.177a1.604 1.604 0 011.178-.487c.46 0 .849.162 1.165.487.315.324.473.716.473 1.177 0 .461-.158.854-.473 1.178a1.562 1.562 0 01-1.165.486zm-.999 6.758h2.1l.384-2.867a5.661 5.661 0 001.433-.576 6.93 6.93 0 001.306-1.01l2.662 1.151.998-1.766-2.33-1.741c.07-.324.125-.614.167-.87.043-.256.064-.504.064-.743 0-.29-.017-.554-.05-.793a4.923 4.923 0 00-.18-.768l2.38-1.792-.998-1.767-2.713 1.127a6.379 6.379 0 00-1.28-1.011c-.512-.316-1.007-.508-1.485-.576L9.958.768h-2.15L7.5 3.61a5.37 5.37 0 00-1.51.55 5.656 5.656 0 00-1.306 1.037L2.022 4.07.998 5.837l2.33 1.715a6.26 6.26 0 00-.166.78 6.206 6.206 0 00.14 2.47L.998 12.519l1.024 1.792 2.637-1.126c.41.443.84.785 1.293 1.024.452.239.96.426 1.523.563l.358 2.841z"
        transform="translate(3.104 2.81)"
        fill={props.fill}
        fillRule="nonzero"
        stroke="none"
        strokeWidth={1}
      />
    </Svg>
  );
}

export function ManageUsers(props) {
  return (
    <Svg
      height="24"
      viewBox="0 96 960 960"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M400 551.385q-49.5 0-84.75-35.25T280 431.385q0-49.501 35.25-84.751 35.25-35.25 84.75-35.25t84.75 35.25Q520 381.884 520 431.385q0 49.5-35.25 84.75T400 551.385ZM120 840.616v-65.847q0-27.615 13.923-47.769t39.308-32.077q48.692-23.692 100.384-39Q325.308 640.615 400 640.615h9.385q3.692 0 8.923.462-4.154 10.308-6.577 20.192-2.423 9.885-4.654 19.346H400q-67.154 0-117.115 13.77-49.962 13.769-90.577 35.615-18.231 9.615-25.27 20.154Q160 760.692 160 774.769v25.846h252q2.923 9.462 7.154 20.347 4.231 10.884 9.308 19.654H120Zm528.461 19.231-5.846-46.154q-16.615-3.462-31.346-11.654-14.731-8.192-26.5-20.808l-43.384 17.231-16.924-28.769L561.231 742q-6.616-17.077-6.616-35.231 0-18.153 6.616-35.23l-36-29.231 16.923-28.77 42.615 18q11-12.615 26.116-20.423 15.115-7.807 31.73-11.269l5.846-46.154h33.847l5.077 46.154q16.615 3.462 31.731 11.385 15.115 7.923 26.115 20.769l42.615-18.462 16.924 29.231-36 29.231q6.615 16.859 6.615 35.122 0 18.263-6.615 34.878l36.769 27.693-16.923 28.769-43.385-17.231q-11.769 12.616-26.5 20.808t-31.346 11.654l-5.077 46.154h-33.847Zm16.223-80.77q29.855 0 51.047-21.26 21.192-21.261 21.192-51.116t-21.26-51.047q-21.261-21.192-51.116-21.192t-51.047 21.26q-21.192 21.26-21.192 51.116 0 29.855 21.26 51.047 21.261 21.192 51.116 21.192ZM400 511.385q33 0 56.5-23.5t23.5-56.5q0-33-23.5-56.5t-56.5-23.5q-33 0-56.5 23.5t-23.5 56.5q0 33 23.5 56.5t56.5 23.5Zm0-80Zm12 369.23Z"
        fill={props.fill ? props.fill : '#000'}
      />
    </Svg>
  );
}

export function Person(props) {
  return (
    <Svg
      height="24"
      viewBox="0 96 960 960"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M480 551.385q-49.5 0-84.75-35.25T360 431.385q0-49.501 35.25-84.751 35.25-35.25 84.75-35.25t84.75 35.25Q600 381.884 600 431.385q0 49.5-35.25 84.75T480 551.385ZM200 840.616v-65.847q0-24.769 14.423-46.346 14.423-21.577 38.808-33.5 56.615-27.154 113.307-40.731Q423.231 640.615 480 640.615q56.769 0 113.462 13.577 56.692 13.577 113.307 40.731 24.385 11.923 38.808 33.5Q760 750 760 774.769v65.847H200Zm40-40.001h480v-25.846q0-13.307-8.577-25-8.577-11.692-23.731-19.769-49.384-23.923-101.836-36.654Q533.405 680.615 480 680.615q-53.405 0-105.856 12.731Q321.692 706.077 272.308 730q-15.154 8.077-23.731 19.769-8.577 11.693-8.577 25v25.846Zm240-289.23q33 0 56.5-23.5t23.5-56.5q0-33-23.5-56.5t-56.5-23.5q-33 0-56.5 23.5t-23.5 56.5q0 33 23.5 56.5t56.5 23.5Zm0-80Zm0 369.23Z"
        fill={props.fill ? props.fill : '#000'}
      />
    </Svg>
  );
}

export const Tick = style => (
  <Svg
    height={style.height || '20'}
    width={style.width || '20'}
    viewBox="0 96 960 960">
    <Path
      fill={style.fill ? style.fill : '#000'}
      d="M382 816 154 588l57-57 171 171 367-367 57 57-424 424Z"
    />
  </Svg>
);

export function TouchableIcon(props) {
  const { children, accessibilityLabel } = props;

  return (
    <Pressable
      hitSlop={10}
      accessible={true}
      accessibilityRole="button"
      {...props}
      style={({ pressed }) => [{ opacity: pressed ? 0.5 : 1 }, props.style]}>
      {/*
       * When the button carries its own label its contents are purely
       * decorative — hide them so the screen reader reads the label instead of
       * describing the SVG's position and colour. The wrapper keeps the row
       * layout these buttons are laid out with (icon beside text).
       */}
      {accessibilityLabel ? (
        <View style={styles.touchableIconContent} {...decorative}>
          {children}
        </View>
      ) : (
        children
      )}
    </Pressable>
  );
}

export function WifiTeathering(props) {
  const { fill } = props;
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <G fill="none" fillRule="evenodd">
        <Path
          fill={fill}
          d="M12 10.918c-.966 0-1.757.79-1.757 1.757 0 .966.79 1.757 1.757 1.757.966 0 1.757-.79 1.757-1.757 0-.966-.79-1.757-1.757-1.757z"
        />
        <Path
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M17 21.325c3.333-2.203 5-5.086 5-8.65 0-5.346-4.488-10-10-10s-10 4.367-10 10c0 3.755 1.667 6.639 5 8.65"
        />
        <Path
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15 17.835c2-1.322 3-3.052 3-5.19 0-3.207-2.693-6-6-6s-6 2.62-6 6c0 2.253 1 3.983 3 5.19"
        />
      </G>
    </Svg>
  );
}

export function Debug(props) {
  return (
    <Svg
      aria-hidden="true"
      data-prefix="fas"
      data-icon="bug"
      className="prefix__svg-inline--fa prefix__fa-bug prefix__fa-w-16"
      viewBox="0 0 512 512"
      {...props}>
      <Path
        fill="#2d7af6"
        d="M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"
      />
    </Svg>
  );
}

export function DetailedInterface({ showHand = true, ...props }) {
  return (
    <Svg viewBox="0 0 234 175" xmlns="http://www.w3.org/2000/svg" {...props}>
      <G stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <G transform="translate(-79 -449) translate(80.8 450.438)">
          <G transform="translate(53.714 37.337)">
            <G transform="translate(77.346)" fill="#2FC3CA">
              <Circle
                opacity={0.297409784}
                cx={4.22720661}
                cy={4.22720661}
                r={4.22720661}
              />
              <Circle
                opacity={0.450962612}
                cx={4.22720661}
                cy={4.22720661}
                r={2.5}
              />
              <Circle cx={4.22720661} cy={4.22720661} r={1.56449894} />
            </G>
            <Circle
              fill="#FAFAFA"
              cx={1.56449894}
              cy={4.22720661}
              r={1.56449894}
            />
            <Circle
              fill="#FAFAFA"
              cx={41.7372604}
              cy={4.22720661}
              r={1.56449894}
            />
            <Circle
              fill="#FAFAFA"
              cx={121.408199}
              cy={4.22720661}
              r={1.56449894}
            />
          </G>
          <G transform="translate(74.418 50)">
            <Circle fill="#FAFAFA" cx={19.5460326} cy={21.2} r={10.4} />
            <Text
              fontFamily="Montserrat-Regular, Montserrat"
              fontSize={6}
              fontWeight="normal"
              fill="#FFF">
              <TSpan x={6.53203263} y={6}>
                {'Override'}
              </TSpan>
            </Text>
            <Circle fill="#FAFAFA" cx={62.3815018} cy={21.2} r={10.4} />
            <Text
              fontFamily="Montserrat-Regular, Montserrat"
              fontSize={6}
              fontWeight="normal"
              fill="#FFF">
              <TSpan x={56.4475018} y={6}>
                {'Pair'}
              </TSpan>
            </Text>
          </G>
          <Circle fill="#FAFAFA" cx={162.177915} cy={71.8110842} r={1.5} />
          <Rect
            stroke="#FAFAFA"
            strokeWidth={2}
            x={0}
            y={0}
            width={230.4}
            height={128}
            rx={8}
          />
          <Rect
            stroke="#FAFAFA"
            x={32}
            y={32}
            width={166.4}
            height={64}
            rx={32}
          />
        </G>
        <Text
          fontFamily="Montserrat-Regular, Montserrat"
          fontSize={6}
          fontWeight="normal"
          fill="#FFF"
          transform="translate(-79 -449) translate(80.8 450.438)">
          <TSpan x={167.348434} y={73.8123245}>
            {'Reset'}
          </TSpan>
        </Text>
        <Text
          fontFamily="Montserrat-Regular, Montserrat"
          fontSize={6}
          fontWeight="normal"
          fill="#FFF"
          transform="translate(-79 -449) translate(80.8 450.438)">
          <TSpan x={164.40322} y={24.5}>
            {'Zigbee'}
          </TSpan>
        </Text>
        <Text
          fontFamily="Montserrat-Regular, Montserrat"
          fontSize={6}
          fontWeight="normal"
          fill="#FFF"
          transform="translate(-79 -449) translate(80.8 450.438)">
          <TSpan x={116.338227} y={24.5}>
            {'Connectivity'}
          </TSpan>
        </Text>
        <Text
          fontFamily="Montserrat-Regular, Montserrat"
          fontSize={6}
          fontWeight="normal"
          fill="#FFF"
          transform="translate(-79 -449) translate(80.8 450.438)">
          {props.boiler ? (
            <TSpan x={86} y={24.5}>
              {'Boiler'}
            </TSpan>
          ) : (
            <TSpan x={74} y={24.5}>
              {'HP Comms'}
            </TSpan>
          )}
        </Text>
        {showHand ? <Path
          d="M205.853 151.38c-.3-.385-.682-1.011-1.126-1.736-1.455-2.377-3.655-5.97-7.195-8.382a215.22 215.22 0 00-2.892-1.906c-7.45-4.861-22.949-14.977-33.316-25.384-10.546-10.585-11.407-11.45-14.685-12.005a21.77 21.77 0 00-3.694-.296l-7.325.022a9.41 9.41 0 01-.938-.62l-14.136-10.61-.045-.032-13.66-9.153a17.914 17.914 0 01-2.396-1.918l-7.415-7.046a2.736 2.736 0 00-4.109.395 6.38 6.38 0 00-.184 7.187 79.967 79.967 0 009.927 12.35.627.627 0 00.055.052l11.146 9.821-5.261 16.209a5.658 5.658 0 00-.091 3.185l1.735 6.63-1.67.199h-.001a5.377 5.377 0 00-4.371 7.294 5.374 5.374 0 003.492 3.2l12.985 3.81c.034.011.07.02.106.025 3.925.716 8.271 3.186 10.512 4.594a37.414 37.414 0 005.338 2.794c2.175.92 5.483 2.274 8.895 3.502 4.134 1.487 7.526 1.948 12.221 2.587 2.445.332 5.217.709 8.601 1.306 9.232 1.628 19.063 15.527 19.162 15.668a1.036 1.036 0 001.695-1.188c-.28-.4 7.98-3.853 24.785-10.357a1.035 1.035 0 001.543-1.38c-.065-.071-6.38-7.128-7.688-8.817z"
          fill="#181818"
          fillRule="nonzero"
          transform="translate(-79 -449) translate(80.8 450.438)"
        /> : null}
        <Text
          fontFamily="Montserrat-Regular, Montserrat"
          fontSize={6}
          fontWeight="normal"
          fill="#FFF"
          transform="translate(-79 -449) translate(80.8 450.438)">
          <TSpan x={46.7588244} y={24.5}>
            {'Power'}
          </TSpan>
        </Text>
        {showHand ? <Path
          d="M118.238 86.028c-.062-.07-6.193-6.918-7.462-8.558-.29-.374-.662-.981-1.092-1.685-1.413-2.307-3.548-5.794-6.984-8.135a208.887 208.887 0 00-2.806-1.85c-7.23-4.719-22.274-14.537-32.337-24.637C57.322 30.889 56.485 30.049 53.304 29.51a21.13 21.13 0 00-3.586-.286l-7.11.02v.002a9.331 9.331 0 01-.909-.602l-13.72-10.299-.044-.031L14.677 9.43v.001a17.478 17.478 0 01-2.326-1.863L5.154.73a2.653 2.653 0 00-3.988.383 6.192 6.192 0 00-.179 6.975 77.615 77.615 0 009.636 11.988.608.608 0 00.053.05l10.819 9.532-5.107 15.732a5.482 5.482 0 00-.089 3.092l1.684 6.435-1.62.192-.002.001a5.218 5.218 0 00-4.242 7.08 5.216 5.216 0 003.39 3.105l12.602 3.698c.034.01.069.02.103.024 3.81.695 8.028 3.092 10.203 4.46h-.001a36.483 36.483 0 005.183 2.71c2.11.894 5.321 2.208 8.633 3.4 4.012 1.443 7.305 1.89 11.861 2.51 2.374.323 5.064.689 8.349 1.269 8.96 1.58 18.502 15.07 18.597 15.206a1.004 1.004 0 101.646-1.152c-.409-.583-10.112-14.309-19.895-16.033-3.323-.586-6.035-.955-8.427-1.28-4.434-.603-7.64-1.038-11.453-2.41-3.268-1.177-6.443-2.477-8.53-3.36h.001a34.38 34.38 0 01-4.895-2.56c-2.794-1.757-6.94-3.998-10.859-4.725l-12.552-3.683v-.001a3.207 3.207 0 01.524-6.262l6.232-.741a13.136 13.136 0 015.69.567c7.322 2.407 12.063 3.144 14.093 2.189.665-.313 1.496-.998 1.684-2.488.44-3.478-3.289-9.98-6.536-12.668-.783-.649-2.292-2.553-4.247-5.36a27.331 27.331 0 00-4.103-4.649l-17.38-15.312A77.144 77.144 0 012.685 7.014a4.202 4.202 0 01.116-4.736.643.643 0 01.97-.092l7.197 6.838c.803.763 1.67 1.457 2.591 2.075l13.236 8.87L40.493 30.25c.38.284.775.545 1.187.78l3.58 2.044.001-.001a21.078 21.078 0 012.933 2.022l2.31 1.901a1.005 1.005 0 001.276-1.552l-2.31-1.9a23.17 23.17 0 00-3.214-2.216l-.15-.086 3.619-.01c1.086-.006 2.172.08 3.244.258 2.453.415 2.945.83 13.165 11.089C76.345 52.83 91.51 62.725 98.797 67.482c1.198.782 2.146 1.4 2.773 1.828 3.08 2.097 5.079 5.362 6.402 7.523.46.754.86 1.405 1.216 1.866 1.312 1.696 7.3 8.385 7.554 8.669a1.004 1.004 0 001.496-1.34zm-89.165-41.03c-.003.064-.006.126-.005.19l.078 9.835a15.577 15.577 0 00-.845-.25l-.918-4.502a1.905 1.905 0 01.086-1.061l1.604-4.211zM42.306 56.38c-.079.626-.334.822-.547.922-.444.21-1.189.276-2.188.208l-.14-5.541a.732.732 0 01.648-.749l.686-.081c1.065 2.066 1.688 4.08 1.541 5.241zm-2.633-7.126a2.745 2.745 0 00-.755.252 5.647 5.647 0 01-2.991-2.458 1.005 1.005 0 00-1.726 1.029 7.686 7.686 0 003.352 3.034 2.78 2.78 0 00-.13.909l.133 5.236a54.659 54.659 0 01-6.396-1.596l-.083-10.488a1.875 1.875 0 01.865-1.6l.97-.623 1.236.205v-.001c.072.011.144.015.217.011.885 1.129 1.595 1.916 2.118 2.348a16.625 16.625 0 013.19 3.742zm-7.807-9.502c.272.39.535.764.788 1.118l-1.775-.294a2.649 2.649 0 00-.745-.015 10.787 10.787 0 00-4.051-4.572 1.004 1.004 0 00-1.094 1.685c1.605 1.042 2.712 2.312 3.386 3.87-.17.211-.307.449-.404.703l-2.245 5.897c-1.148-.504-2.62-.684-4.092-.789a1.007 1.007 0 00-1.074.93 1 1 0 00.243.73.999.999 0 00.689.343c1.288.092 3.04.281 3.86.861.012.153.033.304.063.453l.755 3.701a15.356 15.356 0 00-3.575-.004l-2.597.31-1.755-6.706a3.49 3.49 0 01.058-1.964l4.838-14.905 4.938 4.35h-.001a25.265 25.265 0 013.79 4.298z"
          transform="translate(-79 -449) translate(80.8 450.438) translate(91.72 71.562)"
          fill="#CAE08F"
          fillRule="nonzero"
        /> : null}
      </G>
    </Svg>
  );
}

export const faultIcon = (homeType, severity, props) => {
  if (homeType === 'Halo Air' || homeType === 'Logic Heat Pump') {
    return (
      <HeatPump
        stroke={forSeverity(severity)(300)}
        testID="Heat Pump Icon"
        {...props}
      />
    );
  } else {
    return (
      <Boiler
        stroke={forSeverity(severity)(300)}
        testID="Boiler Icon"
        {...props}
      />
    );
  }
};

export const controlFaultIcon = (faultType, severity, props) => {
  switch (faultType) {
    case 'CF04':
      return <FailCircle fill={forSeverity(severity)(300)} {...props} />;
    default:
      return <FailCircle fill={forSeverity(severity)(300)} {...props} />;
  }
};

export function VerificationCodeBanner(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={227.677}
      height={173.985}
      viewBox="0 0 227.677 173.985"
      {...props}>
      <G fill="none" fillRule="evenodd">
        <G stroke="#D8D8D8" strokeLinecap="round" transform="translate(1 1)">
          <Path
            strokeWidth={2}
            d="M95.94 127.388H8.171c-7.826 0-8.171-1.345-8.171-9.171V8.17C0 .345.345 0 8.171 0h175.424c7.827 0 8.172 1.345 8.172 9.171v51.81"
          />
          <Path d="M7.628 5.052l79.425 63.664a14.171 14.171 0 0017.686.032L184.252 5.49" />
          <Path d="M78.997 62.258L7.11 121.873" />
        </G>
        <G
          fillRule="nonzero"
          stroke="#95C11F"
          strokeLinejoin="round"
          transform="translate(1 1) translate(95.883 43.888)">
          <Path
            strokeWidth={2}
            transform="rotate(-40 64.692 63.844)"
            d="M15.633 76.434L22.568 63.431 15.645 50.449 22.84 21.668 113.752 63.436 22.03 106.02z"
          />
          <Path
            transform="rotate(-40 63.855 64.172)"
            d="M110.709 64.059L110.537 63.98 17.121 51.079 23.393 62.839 24.037 64.046 23.393 65.253 17.001 77.239 17.006 77.264 110.609 64.105z"
          />
        </G>
      </G>
    </Svg>
  );
}

export function GeolocationBanner(props) {
  const { enabled } = props;
  return (
    <Svg
      width={262.201}
      height={138.876}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 262.201 138.876"
      {...props}>
      <G fill="none" fillRule="evenodd" transform="translate(1 1)">
        <Path
          stroke="#FAFAFA"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M37.292 117.28c-12.577-9.555-21.936-18.72-28.079-27.494C3.071 81.01 0 72.43 0 64.046c0-6.24 1.121-11.748 3.364-16.525 2.242-4.778 5.118-8.775 8.628-11.992 3.51-3.218 7.532-5.63 12.065-7.24 4.534-1.608 8.946-2.413 13.235-2.413 4.29 0 8.702.805 13.236 2.413 4.533 1.61 8.555 4.022 12.065 7.24 3.51 3.217 6.41 7.214 8.701 11.992 2.292 4.777 3.437 10.286 3.437 16.525 0 8.385-3.095 16.965-9.286 25.74-6.191 8.774-15.575 17.939-28.153 27.494z"
        />
        <Path
          stroke="#95C11F"
          d="M37.439 71.212c2.242 0 4.143-.78 5.703-2.34 1.56-1.56 2.34-3.46 2.34-5.703 0-2.243-.804-4.144-2.413-5.704-1.609-1.56-3.534-2.34-5.777-2.34-2.242 0-4.143.78-5.703 2.34-1.56 1.56-2.34 3.461-2.34 5.704 0 2.242.804 4.144 2.413 5.703 1.609 1.56 3.534 2.34 5.777 2.34z"
        />
        <Path
          stroke="#95C11F"
          strokeLinejoin="round"
          d="M0 136.876h74.731H0z"
        />
        <Path
          stroke="#FAFAFA"
          strokeLinejoin="round"
          d="M226.034 33.278L237.771 33.278 237.771 21.541 226.034 21.541z"
        />
        <Path
          stroke="#FAFAFA"
          strokeLinejoin="round"
          d="M226.034 70.519L237.771 70.519 237.771 58.782 226.034 58.782z"
        />
        <Path
          stroke="#FAFAFA"
          strokeLinejoin="round"
          d="M226.034 107.535L237.771 107.535 237.771 95.798 226.034 95.798z"
        />
        <Path
          stroke={enabled ? '#95C11F' : '#FAFAFA'}
          strokeLinejoin="round"
          strokeWidth={enabled ? 3 : 1}
          d="M87 136.876L87 61.491 140.041 23.798 192.856 61.265 192.856 136.876 152.906 136.876 152.906 96.249 126.95 96.249 126.95 136.876z"
        />
        <Path d="M159.903 130.105L159.903 89.478 120.179 89.478 120.179 130.105 120.179 89.478 159.903 89.478z" />
        <Path
          stroke="#FAFAFA"
          strokeLinecap="round"
          strokeWidth={2}
          d="M169.577 25.876L169.577 0 260.201 0 260.201 136.876 209.107 136.876"
        />
      </G>
    </Svg>
  );
}

export const CrossHairs = props => (
  <Svg width={25} height={25} viewBox="0 0 24 24" {...props}>
    <Path d="M0 0h24v24H0z" fill="none" />
    <Path
      d="M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
      fill="#fff"
    />
  </Svg>
);

export const ArrowPath = props => (
  <Svg
    width={25}
    height={25}
    fill="none"
    stroke="#FAFAFA"
    strokeWidth={1.5}
    viewBox="0 0 24 24"
    {...props}>
    <Path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
    />
  </Svg>
);

export function Search(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      {...props}>
      <Path
        stroke="#FAFAFA"
        d="M19.46 20.013l-6.272-6.273a4.75 4.75 0 01-1.69 1.005 5.833 5.833 0 01-1.936.343c-1.568 0-2.887-.535-3.957-1.605C4.535 12.413 4 11.102 4 9.55s.53-2.867 1.593-3.945c1.061-1.078 2.368-1.617 3.92-1.617s2.87.54 3.957 1.617c1.086 1.078 1.63 2.393 1.63 3.945 0 .67-.123 1.327-.368 1.972a5.308 5.308 0 01-1.005 1.679L20 19.449l-.54.564zm-9.898-5.66c1.34 0 2.475-.462 3.406-1.385.93-.923 1.396-2.062 1.396-3.418 0-1.372-.465-2.516-1.396-3.43-.931-.915-2.075-1.372-3.43-1.372-1.356 0-2.496.461-3.419 1.384-.922.923-1.384 2.062-1.384 3.418 0 1.356.466 2.495 1.397 3.418.93.923 2.074 1.384 3.43 1.384z"
      />
    </Svg>
  );
}

export function Informative(props) {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={154} height={154} {...props}>
      <G fill="none" fillRule="evenodd" transform="translate(21 21)">
        <Circle cx={56} cy={56} r={40} fill="#666" />
        <Path
          fill="#B5D462"
          fillRule="nonzero"
          d="M74.872 10.967a2.64 2.64 0 0 1 2.062-4.86 55.291 55.291 0 0 1 3.954 1.845 54.376 54.376 0 0 1 3.784 2.157c12.67 7.916 20.934 20.221 24.05 33.716 3.115 13.494 1.084 28.173-6.835 40.847-7.917 12.67-20.222 20.935-33.717 24.05-13.494 3.116-28.173 1.084-40.847-6.835C14.653 93.97 6.389 81.665 3.273 68.17.158 54.677 2.189 39.997 10.108 27.323a53.973 53.973 0 0 1 11.04-12.724 53.921 53.921 0 0 1 14.433-8.706 2.645 2.645 0 1 1 1.988 4.903 48.648 48.648 0 0 0-13.009 7.836 48.819 48.819 0 0 0-9.957 11.5C7.459 41.562 5.625 54.805 8.437 66.977c2.81 12.17 10.262 23.271 21.694 30.414 11.432 7.144 24.677 8.975 36.846 6.166C79.15 100.75 90.25 93.296 97.392 81.864c7.143-11.432 8.978-24.675 6.166-36.847-2.808-12.172-10.263-23.27-21.694-30.414a49.777 49.777 0 0 0-6.994-3.637l.002.001Z"
        />
        <G stroke="#B5D462" strokeLinecap="round" strokeWidth={5}>
          <Path d="M56.06 75.246 56 23M56 7.247l.03 1.953" />
        </G>
      </G>
    </Svg>
  );
}

export function BluetoothInstructions(props) {
  return (
    <Svg width={264} height={196} {...props}>
      <G fill="#fff">
        <Path
          fill="#FFF"
          d="M1 188c0 4 4 7 8 7h248c3 0 6-3 6-7V18c0-4-3-7-8-7H7c-3 1-6 3-6 7v170z"
        />
        <Path
          stroke="#666"
          d="M1 18v170c0 4 4 7 8 7h248c3 0 6-3 6-7V18c0-4-3-7-8-7H7c-3 1-6 3-6 7z"
        />
        <Path
          fill="#fFF"
          d="M108 117v11c0 3 3 5 5 5h39c2-1 4-2 4-5v-11c0-3-3-5-5-5h-39c-2 1-4 2-4 5"
        />
        <Path
          stroke="#666"
          d="M108 127v11c0 3 2 5 5 5h40c2-1 3-2 3-5v-11c0-3-2-5-5-5h-40c-2 1-3 2-3 5z"
        />
        <Path
          fill="#666"
          d="M170 66a2 2 0 11-4 0 2 2 0 014 0m-72 0a2 2 0 11-5 0 2 2 0 015 0m36 101a2 2 0 11-4 0 2 2 0 014 0"
        />
        <Path
          fill="#27C9C4"
          fillOpacity={0.2}
          d="M132 131a65 65 0 110-130 65 65 0 010 130z"
        />
        <Path
          fill="#27C9C4"
          fillOpacity={0.5}
          d="M132 95a29 29 0 110-58 29 29 0 010 58z"
        />
        <Path fill="#4C9294" d="M134 66a2 2 0 11-4 0 2 2 0 014 0" />
      </G>
    </Svg>
  );
}

export function Linked() {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64">
      <Circle cx={32} cy={32} r={32} fill="#5F5665" />
      <G fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <G transform="translate(-164 -340)">
          <G transform="translate(164 340)">
            <Path d="M0 0H64V64H0z" />
            <Path
              stroke="#FFF"
              strokeWidth="1.909"
              d="M19.2 17.92L46.08 44.8 32 58.88 32 5.12 46.08 19.2 19.2 46.08"
            />
          </G>
        </G>
      </G>
    </Svg>
  );
}

export function BluetoothOn(props) {
  return (
    <Svg height={233} width={196} viewBox="0 0 233 195" {...props}>
      <Path
        fill="#4c4c4c"
        d="M111.7 181.1l9-9 11.4-11.4 22.3-22.3 22.7-22.7v-.1l22.7-22.7 15.1-15.1-2.9-3.3-17.7 17.6v.1l-17.2 17.2v.1l-22.3 22.3-22.7 22.7v.1l-22.7 22.7-12.5 12.4 2.3 3.9.1-.1zm.1-13.3l20.3-20.3 22.3-22.3 22.7-22.7v-.1l22.7-22.7 6.2-6.2h.1l3.2-3.2.7-7-15.7 15.6v.1l-17.2 17.2v.1l-22.3 22.3-22.7 22.7v.1L109.4 164v.1l-17.3 17.2 2.3 3.9zm82.5-22.8l-14.2 14.2-.7.7-22.3 22.3-6.3 6.4 4.3 1.9 1.6-1.7 18.8-18.7 3.6-6.3 3.3-.7 19.2-19.2 8.9-8.9-.6-5.6-15.6 15.5zm-60.5 27.1l.6-.6v.1l9-9 11-11 22.7-22.7v-.1l22.7-22.7 17.3-17.3v-.1l4-4-2.9-3.3-1.2 1.2-22.7 22.7v.1l-17.2 17.2v.1L154.8 145l-22.7 22.7v.1l-19.7 19.6-.4.4 11.2-5 10.7-10.7zM217 95.8l-22.7 22.7v.1l-17.2 17.2v.1l-22.3 22.3-19.7 19.6-.7.8-1.8 1.8 4.2 1.9 19.8-19.7.1-.2 9-8.9 11.4-11.4v-.1l22.7-22.7 17.3-17.3v-.1l10.3-10.3-3-3.2zm-51 90.8l-6.1 6.1 2.1.9zm28.3-28.4l-3 3 7.9-1.7 3-2.9v-.1l9.5-9.5-.6-5.7-16.8 16.8zm-82.5-3.6l20.3-20.3 22.3-22.3 22.7-22.7v-.1l19.7-19.8v.1l14-13.9.7-7-11.7 11.8v-.1l-2.7 2.7-2.8 2.7v.1L177.1 83v.1l-22.3 22.3-22.7 22.7v.1l-22.7 22.6v.1l-20.3 20.2v.1l-1.8 1.8 2.3 3.9zM217 109l-22.7 22.7v.1L177.1 149v.1l-19.7 19.6-.7.7-15 15.1 4.3 1.9 10.7-10.8 22.2-22.1h-.1l.6-.6 9-9 11.4-11.4 9.4-9.4-.1-.6 23-25.6-1.4-1.6zM89.1 164.1l22.7-22.7 20.3-20.3 22.7-22.7 22.3-22.3V76l19.7-19.8v.1l15.6-15.5.3-3.6-2.4-.5-10.5 10.5v-.1l-22.7 22.7v.1l-22.3 22.3-22.7 22.7v.1l-22.7 22.6v.1l-20.3 20.2v.1l-6.6 6.6 2.3 3.9 4.3-4.3zm0-26.4l22.7-22.7 20.3-20.3 22.3-22.3 9.2-9.3 13.5-13.4v-.1l16.4-16.4-5.1-1.1-8.5 8.6h-.1l-2.7 2.7v.1l-6.7 6.7h-.1l-15.9 16-22.3 22.3v.1l-22.7 22.6v.1l-20.3 20.2v.1l-22.3 22.3-5.5 5.5 5.1 1.1 22.7-22.7zm123.6 18.9l-.3-3.3-4.4 4.3zm-123.6-5.7l22.7-22.7 20.3-20.3 22.3-22.3 22.7-22.7v-.1l9.2-9.2 10.5-10.5 7.7-7.6-5.2-1.1-6.2 6.3h-.1l-15.9 15.9v.1L154.8 79l-22.7 22.7v.1l-22.7 22.6v.1l-20.3 20.2v.1l-16.9 16.9 5.1 1.1L89.1 151zm0-26.3v-.1l22.7-22.7 20.3-20.3 9.2-9.2 13.1-13.1 22.7-22.7v-.1l5.6-5.5-3.6-.8-.7-1.2-1.3 1.3v.1l-19.9 19.9-2.8 2.8-6.4 6.3-15.9 16v.1L109.4 98v.1l-20.3 20.2v.1l-22.3 22.3-16.4 16.4 5.1 1.1 10.9-10.9zm0-13.2v-.1l9.2-9.2 13.5-13.5 6.8-6.8 13.5-13.5L154.4 46l21.5-21.5-2.3-3.9-18.8 18.8-20 19.9-2.7 2.8v.1l-6.8 6.7-15.9 15.9v.1l-4.3 4.3-16 15.9v.1l-22.3 22.3-17.1 17.1-.8 6.9 17.5-17.4zm-22.7 9.5l9.2-9.3h.1l13.4-13.4v-.1l22.7-22.7 20.3-20.3 22.3-22.3 16.7-16.7-2.3-3.9-14 14-22.7 22.7v.1l-20 19.9-2.7 2.8-17.5 17.5-2.8 2.8-6.7 6.7-16 16-15.2 15.2-.7 6.9zm0-26.4l22.7-22.7v-.1L111.8 49l20.3-20.3L154.8 6V3.5l-6.8 3-15.9 16v.1l-22.7 22.7-20.3 20.3-22.3 22.3-19.9 19.9-2.8 2.8v.1l-1.4 1.4 2.9 3.2zm-13.1 26.3l13.1-13.1L89.1 85v-.1l22.7-22.7 20.3-20.3 22.3-22.3 11.8-11.9-2.2-3.9-9.2 9.2-22.7 22.7v.1l-22.7 22.7-20.3 20.3-19.9 19.9-2.8 2.8-6.3 6.3H60L48.9 119l2.9 3.3zm-9.2-17.2l22.3-22.3 22.7-22.7v-.1l22.7-22.7 20.3-20.3 3.3-3.3-4.8 2.1-2.4-1-18.8 18.8-20.3 20.3-22.3 22.3-22.7 22.7v.1l-7.7 7.7 2.9 3.2zm0-13.2l22.3-22.3 22.7-22.7v-.1l22.7-22.7 11.5-11.5-4.3-1.9-9.6 9.7-20.3 20.3-22.3 22.3-22.7 22.7v.1l-14 13.9 3 3.3zm45-58.2v-.1l22.7-22.7 2.4-2.4-4.3-1.9-.5.6L89.1 26 66.8 48.3 51.2 63.9l.6 5.6 14.6-14.6zm-12.2-1L69 32.9l-2.2 2.2-16.9 16.8.6 5.7 15.9-15.9zM89.1 19v-.1l16-15.9-4.3-2L96 5.9l-8.5 14.7zM52.3 36.4L48.7 40l.6 5.6 10.9-10.9z"
      />
      <Path
        fill={props.fill || '#fff'}
        stroke="#333"
        d="M71.7 193.9l-17.2-29.8-33.6-7.1 3.6-34.2-23-25.5 23-25.5-3.6-34.2 33.6-7.1L71.7.7l31.4 14 31.4-14 17.2 29.8 33.6 7.1-3.6 34.2 23 25.5-23 25.5 3.6 34.2-33.6 7.1-17.2 29.8-31.4-14-31.4 14z"
      />
      <Path
        fill="#fff"
        stroke="#333"
        d="M77 76.2c-13.6 0-24.5 10.4-24.5 23.2s11 23.2 24.5 23.2 24.5-10.4 24.5-23.2-11-23.2-24.5-23.2zm0 37.5c-7.7 0-14-6.4-14-14.3s6.3-14.3 14-14.3 14 6.4 14 14.3-6.3 14.3-14 14.3zM150.4 77v44.8h-8.5l-22.3-27.2v27.2h-10.2V77h8.6l22.3 27.2V77h10.1z"
      />
    </Svg>
  );
}

export function ExclamationMark(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="188"
      height="188"
      viewBox="0 0 88 88"
      {...props}>
      <G fill="none" fill-rule="evenodd">
        <Circle cx="44" cy="44" r="44" fill={props.fill} />
        <Rect
          width="10"
          height="41"
          x="1"
          y="1"
          stroke="#FAFAFA"
          stroke-width="2"
          rx="5"
          transform="translate(38 13.33)"
        />
        <Rect
          width="10"
          height="10"
          x="1"
          y="1"
          stroke="#FAFAFA"
          stroke-width="2"
          rx="5"
          transform="translate(38 62.935)"
        />
      </G>
    </Svg>
  );
}

export function DsrSettings(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={24}
      height={24}
      viewBox="0 0 32 32"
      {...props}>
      <Defs>
        <Path
          id="a"
          d="M25.8 8.053C24.893 3.453 20.853 0 16 0a9.994 9.994 0 00-8.867 5.387A7.992 7.992 0 000 13.333c0 4.414 3.587 8 8 8h17.333A6.67 6.67 0 0032 14.667c0-3.52-2.733-6.374-6.2-6.614zm-.467 10.614H8a5.332 5.332 0 01-5.333-5.334A5.332 5.332 0 018 8h.947C9.827 4.92 12.64 2.667 16 2.667A7.33 7.33 0 0123.333 10v.667h2c2.214 0 4 1.786 4 4 0 2.213-1.786 4-4 4z"
          stroke="#000"
          strokeWidth={1.5}
        />
        <Path id="c" d="M0 0H66.667V66.667H0z" stroke="#000" />
      </Defs>
      <G fill="none" fillRule="evenodd" transform="translate(0 5.333)">
        <Mask id="b" fill="#fff">
          <Use xlinkHref="#a" />
        </Mask>
        <G mask="url(#b)">
          <Use
            fill="#CAE08F"
            transform="translate(-17.333 -22.667)"
            xlinkHref="#c"
          />
        </G>
      </G>
    </Svg>
  );
}

export function QrCode(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={24}
      height={24}
      strokeWidth={1.5}
      stroke="#A0C735"
      className="size-6"
      {...props}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 013.75 9.375v-4.5zm0 9.75c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 01-1.125-1.125v-4.5zm9.75-9.75c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0113.5 9.375v-4.5z"
      />
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.75 6.75h.75v.75h-.75v-.75zm0 9.75h.75v.75h-.75v-.75zm9.75-9.75h.75v.75h-.75v-.75zm-3 6.75h.75v.75h-.75v-.75zm0 6h.75v.75h-.75v-.75zm6-6h.75v.75h-.75v-.75zm0 6h.75v.75h-.75v-.75zm-3-3h.75v.75h-.75v-.75z"
      />
    </Svg>
  );
}

// Hero icons Signal icon
export function Signal(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="white"
      className="size-6"
      {...props}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.348 14.652a3.75 3.75 0 010-5.304m5.304 0a3.75 3.75 0 010 5.304m-7.425 2.121a6.75 6.75 0 010-9.546m9.546 0a6.75 6.75 0 010 9.546M5.106 18.894c-3.808-3.807-3.808-9.98 0-13.788m13.788 0c3.808 3.807 3.808 9.98 0 13.788M12 12h.008v.008H12V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
      />
    </Svg>
  );
}

// Hero icons Wifi icon
export function Wifi(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="white"
      className="size-6"
      {...props}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.288 15.038a5.25 5.25 0 017.424 0M5.106 11.856c3.807-3.808 9.98-3.808 13.788 0M1.924 8.674c5.565-5.565 14.587-5.565 20.152 0M12.53 18.22l-.53.53-.53-.53a.75.75 0 011.06 0z"
      />
    </Svg>
  );
}

// Hero icons Arrow-up-down
export function ArrowsUpDown(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="white"
      className="size-6"
      {...props}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 7.5L7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
      />
    </Svg>
  );
}

// Hero icons arrow-top-right-on-square (external link icon)
export const ArrowTopRightOnSquare = props => {
  const { disabled } = props;

  return (
    <Svg
      height={24}
      width={24}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      className="size-6"
      viewBox="0 0 24 24"
      {...props}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        color={disabled ? 'grey' : '#FFFFFF'}
        d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
    </Svg>
  );
};

// Hero icons arrow-right-on-rectangle (exit / sign out)
export const ArrowRightOnRectangle = props => {
  const { disabled } = props;

  return (
    <Svg
      height={24}
      width={24}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      viewBox="0 0 24 24"
      {...props}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        color={disabled ? 'grey' : '#FFFFFF'}
        d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
    </Svg>
  );
};

// Hero icons Check-circle
export function CheckCircle(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="white"
      className="size-6"
      {...props}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </Svg>
  );
}

export function DsrActive(props) {
  return (
    <Svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21.76 19.77"
      {...props}>
      <Defs />
      <Path
        className="cls-1"
        d="M19.73 9.15C19.35 4.04 15.09 0 9.88 0S0 4.43 0 9.88s4.43 9.88 9.88 9.88c.28 0 .5-.22.5-.5s-.22-.5-.5-.5C4.98 18.76 1 14.78 1 9.88S4.98 1 9.88 1s8.47 3.6 8.84 8.15h-1.96l2.49 4.32 2.49-4.32h-2.03z"
      />
      <Path
        className="cls-1"
        d="M3.25 8.08v4.2h1.91c1.37 0 2.32-.83 2.32-2.1s-.94-2.1-2.32-2.1H3.25zm3.24 2.1c0 .8-.55 1.3-1.38 1.3h-.89v-2.6h.89c.83 0 1.38.5 1.38 1.3zM8.93 9.26c0-.26.22-.48.8-.48.37 0 .77.11 1.16.33l.3-.74C10.8 8.12 10.26 8 9.73 8c-1.19 0-1.77.59-1.77 1.31 0 1.56 2.44 1.02 2.44 1.81 0 .26-.23.45-.81.45-.5 0-1.03-.18-1.38-.44l-.33.73c.37.29 1.04.49 1.71.49 1.2 0 1.78-.6 1.78-1.3 0-1.54-2.44-1.01-2.44-1.78zM15.68 9.6c0-.94-.7-1.52-1.82-1.52h-1.82v4.2h.97v-1.17h.89l.81 1.17h1.04l-.94-1.35c.55-.23.86-.7.86-1.33zm-1.88.73h-.79V8.87h.79c.59 0 .89.27.89.73s-.3.73-.89.73z"
      />
    </Svg>
  );
}

export function PlayCircle(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      className="size-6"
      {...props}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
      />
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.91 11.672a.375.375 0 0 1 0 .656l-5.603 3.113a.375.375 0 0 1-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112Z"
      />
    </Svg>
  );
}

export function BookOpen(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-6"
      {...props}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25"
      />
    </Svg>
  );
}

export function QuestionMarkCircle(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-6"
      {...props}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"
      />
    </Svg>
  );
}

export function WrenchScrewdriver(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-6"
      {...props}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.4194 15.1694L17.25 21C18.2855 22.0355 19.9645 22.0355 21 21C22.0355 19.9645 22.0355 18.2855 21 17.25L15.1233 11.3733M11.4194 15.1694L13.9155 12.1383C14.2315 11.7546 14.6542 11.5132 15.1233 11.3733M11.4194 15.1694L6.76432 20.8219C6.28037 21.4096 5.55897 21.75 4.79768 21.75C3.39064 21.75 2.25 20.6094 2.25 19.2023C2.25 18.441 2.59044 17.7196 3.1781 17.2357L10.0146 11.6056M15.1233 11.3733C15.6727 11.2094 16.2858 11.1848 16.8659 11.2338C16.9925 11.2445 17.1206 11.25 17.25 11.25C19.7353 11.25 21.75 9.23528 21.75 6.75C21.75 6.08973 21.6078 5.46268 21.3523 4.89779L18.0762 8.17397C16.9605 7.91785 16.0823 7.03963 15.8262 5.92397L19.1024 2.64774C18.5375 2.39223 17.9103 2.25 17.25 2.25C14.7647 2.25 12.75 4.26472 12.75 6.75C12.75 6.87938 12.7555 7.00749 12.7662 7.13411C12.8571 8.20956 12.6948 9.39841 11.8617 10.0845L11.7596 10.1686M10.0146 11.6056L5.90901 7.5H4.5L2.25 3.75L3.75 2.25L7.5 4.5V5.90901L11.7596 10.1686M10.0146 11.6056L11.7596 10.1686M18.375 18.375L15.75 15.75M4.86723 19.125H4.87473V19.1325H4.86723V19.125Z"
      />
    </Svg>
  );
}

// Named for the set rather than plainly, since [Clock] is already the
// Material glyph with the plus.
export function ClockOutline(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-6"
      {...props}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
      />
    </Svg>
  );
}

export function Envelope(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="#A0C735"
      strokeWidth="1.5"
      className="size-6"
      viewBox="0 0 24 24"
      {...props}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
    </Svg>
  );
}

export function Scale(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-6"
      {...props}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3v17.25m0 0c-1.472 0-2.882.265-4.185.75M12 20.25c1.472 0 2.882.265 4.185.75M18.75 4.97A48.416 48.416 0 0 0 12 4.5c-2.291 0-4.545.16-6.75.47m13.5 0c1.01.143 2.01.317 3 .52m-3-.52 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.988 5.988 0 0 1-2.031.352 5.988 5.988 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L18.75 4.971Zm-16.5.52c.99-.203 1.99-.377 3-.52m0 0 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.989 5.989 0 0 1-2.031.352 5.989 5.989 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L5.25 4.971Z"
      />
    </Svg>
  );
}

export function User(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-6"
      {...props}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
      />
    </Svg>
  );
}

export function Flame(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-6"
      {...props}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.362 5.214A8.252 8.252 0 0 1 12 21 8.25 8.25 0 0 1 6.038 7.047 8.287 8.287 0 0 0 9 9.601a8.983 8.983 0 0 1 3.361-6.867 8.21 8.21 0 0 0 3 2.48Z"
      />
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 18a3.75 3.75 0 0 0 .495-7.468 5.99 5.99 0 0 0-1.925 3.547 5.975 5.975 0 0 1-2.133-1.001A3.75 3.75 0 0 0 12 18Z"
      />
    </Svg>
  );
}

export function CurrencyDollar(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-6"
      {...props}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
      />
    </Svg>
  );
}

export function CurrencyPound(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-6"
      {...props}>
      <Path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.121 7.629A3 3 0 0 0 9.017 9.43c-.023.212-.002.425.028.636l.506 3.541a4.5 4.5 0 0 1-.43 2.65L9 16.5l1.539-.513a2.25 2.25 0 0 1 1.422 0l.655.218a2.25 2.25 0 0 0 1.718-.122L15 15.75M8.25 12H12m9 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
      />
    </Svg>
  );
}

const styles = StyleSheet.create({
  notificationCount: {
    position: 'absolute',
    top: -8,
    right: -8,
  },
  notificationBellContainer: {
    position: 'relative',
  },
  touchableIconContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});
